import { InboxOutlined } from "@ant-design/icons";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { EyeIcon } from "@heroicons/react/16/solid";
import { ClipboardDocumentIcon } from "@heroicons/react/20/solid";
import {
  PlusIcon,
  ShoppingCartIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { message } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useCallback, useEffect, useRef, useState } from "react";
import { WhatsappTemplateCategoryEnum } from "../../enums";
import { deleteEdge } from "../../functions/deleteEdge";
import { handleBeforeUploadFile } from "../../functions/handleBeforeUploadFile";
import { handleUploadFile } from "../../functions/handleUploadFile";
import { saveScenarioFlow } from "../../functions/saveScenarioFlow";
import { DialogConvertAnswer } from "../../nodes/shared";
import { conditionOperators } from "../../nodes/utils-conditionNode/condition-operators.const";
import { AIChatbot } from "../ai-chatbot/AIChatbot";
import { CarouselPanel } from "../carousel/CarouselPanel";
import { DialogConvertCompressFile } from "../DialogConvertCompressFile";
import { ExtractUserMessage } from "../ExtractUserMessage";
import { handleMessageChange } from "../handleMessageChange";
import { handleTemplateSelectionChange } from "../handleSelectedTemplateChange";
import { handleShouldBeReplaced } from "../handleShouldBeReplaced";
import { LimitedTimeOffer } from "../limited-time-offer/LimitedTimeOffer";
import ProductPicker from "../ProductPicker";
import { Button } from "../tailwind/button";
import {
  Dialog as TailwindDialog,
  DialogActions as TailwindDialogActions,
  DialogBody as TailwindDialogBody,
  DialogTitle as TailwindDialogTitle,
} from "../tailwind/dialog";
import { Divider } from "../tailwind/divider";
import { Description, Field, Label, Legend } from "../tailwind/fieldset";
import { Heading } from "../tailwind/heading";
import { Input, InputGroup } from "../tailwind/input";
import { Link } from "../tailwind/link";
import { Select } from "../tailwind/select";
import SelectInput from "../tailwind/select-input";
import { SwitchOnOff, Switch } from "../tailwind/switch";
import { Text } from "../tailwind/text";
import { Textarea } from "../tailwind/textarea";
import TemplateForm from "../templateForm";
import { TemplatePreview } from "../TemplatePreview";
import { submitTemplate } from "../templateSubmit";
import { Tooltip } from "../Tooltip";
import { ManageMessage, ManageTagAutocomplete, ManageTrigger } from "./shared";
import { useParameters } from "./shared/panel/hooks";
import WebhookNodePanel from "./WebhookNodePanel";

export const Panel = ({
  api,
  selectedNode,
  nodes,
  setNodes,
  TagAutocompleteCondition,
  edges,
  setEdges,
  user,
  isUploading,
  setIsUploading,
  isEmojiPickerVisible,
  setIsEmojiPickerVisible,
  templates,
  templatesByName,
  isPanelOpened,
  setIsPanelOpened,
  deleteElements,
  integrations,
  scenario,
  setModifications,
  campaignId,
  isLoading,
  setIsLoading,
  isSubmitLoading,
  setIsSubmitLoading,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const [dialogConvertAnswerData, setDialogConvertAnswerData] = useState({
    isModalOpen: false,
  });

  const handleConvertToAnswer = useCallback(() => {
    setIsPanelOpened(false);
    setDialogConvertAnswerData((prev) => ({ ...prev, isModalOpen: true }));
  }, []);

  // ProductPicker dialog state
  const [productPickerDialogData, setProductPickerDialogData] = useState({
    isModalOpen: false,
  });

  const handleOpenProductPicker = useCallback(() => {
    setIsPanelOpened(false);
    setProductPickerDialogData((prev) => ({ ...prev, isModalOpen: true }));
  }, []);

  const [, setActiveSumbit] = useState(false);
  const [activeErrorSubmitting, setActiveErrorSumbitting] = useState(false);
  const toggleActiveSumbit = useCallback(
    () => setActiveSumbit((active) => !active),
    [],
  );
  const toggleActiveErrorSumbitting = useCallback(
    () => setActiveErrorSumbitting((active) => !active),
    [],
  );
  const [templateName, setTemplateName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(
    WhatsappTemplateCategoryEnum.UTILITY,
  );
  const [selectedHeader, setSelectedHeader] = useState(["none"]);
  const [selectedCardsHeader, setSelectedCardsHeader] = useState(["image"]);
  const [limitedTimeOffer, setLimitedTimeOffer] = useState(null);
  const [isLimitedTimeOffer, setIsLimitedTimeOffer] = useState(false);
  const [cards, setCards] = useState(null);

  const [body, setBody] = useState("");
  const [footer, setFooter] = useState("");

  const [numberOfQuickReplies, setNumberOfQuickReplies] = useState(0);
  const [numberOfUrl, setNumberOfUrl] = useState(0);
  const [copyCodeButton, setCopyCodeButton] = useState(null);
  const [quickReply1, setQuickReply1] = useState("");
  const [quickReply2, setQuickReply2] = useState("");
  const [quickReply3, setQuickReply3] = useState("");
  const [replyButtons, setReplyButtons] = useState(
    selectedNode?.data?.buttons || [],
  );

  const [urlButton, setUrlButton] = useState("");
  const [urlButtonLink, setUrlButtonLink] = useState("");
  const [urlButton2, setUrlButton2] = useState("");
  const [urlButtonLink2, setUrlButtonLink2] = useState("");
  const [bodyParameters, setBodyParameters] = useState([]);
  const [headerImageLink, setHeaderImageLink] = useState([]);
  const [headerVideoLink, setHeaderVideoLink] = useState([]);
  const [shopifyUpsellLineItems, setShopifyUpsellLineItems] = useState([]);

  const [isUrlButtonAtBottom, setIsUrlButtonAtBottom] = useState(false);
  const [messageErrors, setMessageErrors] = useState({});
  const [templateNameError, setTemplateNameError] = useState("");
  const [bodyErrorMsg, setBodyErrorMsg] = useState("");
  const [quickReply1ErrorMsg, setQuickReply1ErrorMsg] = useState("");
  const [quickReply2ErrorMsg, setQuickReply2ErrorMsg] = useState("");
  const [quickReply3ErrorMsg, setQuickReply3ErrorMsg] = useState("");
  const [urlButtonErrorMsg, setUrlButtonErrorMsg] = useState("");
  const [urlButtonLinkErrorMsg, setUrlButtonLinkErrorMsg] = useState("");
  const [urlButton2ErrorMsg, setUrlButton2ErrorMsg] = useState("");
  const [urlButtonLink2ErrorMsg, setUrlButtonLink2ErrorMsg] = useState("");
  const [limitedTimeOfferTextError, setLimitedTimeOfferTextError] =
    useState("");
  const [customField1ErrorMsg, setCustomField1ErrorMsg] = useState("");
  const [customField2ErrorMsg, setCustomField2ErrorMsg] = useState("");
  const [customField3ErrorMsg, setCustomField3ErrorMsg] = useState("");
  const [bodyCardErrors, setBodyCardErrors] = useState([]);
  const [buttonCardErrors, setButtonCardErrors] = useState([]);
  const [newTemplateName, setNewTemplateName] = useState(null);
  const [submitedNode, setSubmitedNode] = useState(null);
  const [carouselCardIndex, setCarouselCardIndex] = useState(null);
  const [carouselComponentIndex, setCarouselComponentIndex] = useState(null);

  const templateNameRef = useRef(null);
  const bodyRef = useRef(null);
  const quickReply1Ref = useRef(null);
  const quickReply2Ref = useRef(null);
  const quickReply3Ref = useRef(null);
  const urlButtonLinkRef = useRef(null);
  const urlButtonLink2Ref = useRef(null);
  const bodyCardRefs = useRef({});
  const buttonCardRefs = useRef({});

  const [gaiaWebsiteDatasources, setGaiaWebsiteDatasources] = useState(
    user.customer.isGaiaActivated
      ? (user.customer.gaiaWebsiteDatasources ?? [{ id: null, url: "" }])
      : null,
  );

  const checkData = useCallback(() => {
    if (!selectedNode || !selectedNode.data) {
      return false;
    }

    if (selectedNode.type !== "message") {
      return true;
    }

    const {
      urlButton,
      urlButtonLink,
      footer,
      buttons,
      documentName,
      document,
      body,
    } = selectedNode.data;

    const _errors = {};

    const urlButtonInvalid =
      (urlButton && !urlButtonLink) || (!urlButton && urlButtonLink);

    if (urlButtonInvalid) {
      _errors.urlButtonInvalid = true;
    }

    if (
      footer &&
      !(urlButton?.text || urlButton?.url) &&
      !(buttons || []).length
    ) {
      _errors.footerMissingButton = true;
    }

    if (
      !body &&
      (urlButton?.text || urlButton?.url || (buttons || []).length)
    ) {
      _errors.bodyRequired = true;
    }

    const documentInvalid =
      (documentName && !document) || (!documentName && document);

    if (documentInvalid) {
      _errors.documentInvalid = true;
    }

    setMessageErrors(_errors);
    return !Object.keys(_errors).length;
  }, [selectedNode]);

  useEffect(() => {
    if (newTemplateName && submitedNode) {
      console.log("newTemplateName valide:", newTemplateName);
      console.log("node to rename", submitedNode);
      setIsLoading(true);
      const nodeToUpdate = nodes.find((n) => n.id === submitedNode.id);
      console.log("node to update", nodeToUpdate);
      handleMessageChange(
        "whatsappTemplateName",
        newTemplateName,
        nodes,
        setNodes,
        nodeToUpdate,
      );
      nodeToUpdate.data.shouldbereplaced;
      nodeToUpdate.data.isEditing = false;
      const updatedNodes = [...nodes];
      setSubmitedNode(null);
      saveScenarioFlow(updatedNodes, edges, scenario.id, campaignId, user)
        .catch((e) => console.error(`Error saving flow after submit: ${e}`))
        .finally(() => setIsLoading(false));
    }
  }, [newTemplateName]);

  useEffect(() => {
    if (activeErrorSubmitting) {
      setIsPanelOpened(false);
    }
  }, [activeErrorSubmitting]);

  useEffect(() => {
    if (
      selectedNode?.data?.gaiaWebsiteDatasources?.length ||
      user.customer.gaiaWebsiteDatasources?.length
    ) {
      const _gaiaWebsiteDatasources = (
        selectedNode?.data?.gaiaWebsiteDatasources || []
      ).filter(({ url }) => url !== "");
      setGaiaWebsiteDatasources(
        [].concat(
          _gaiaWebsiteDatasources.length
            ? _gaiaWebsiteDatasources
            : user.customer.gaiaWebsiteDatasources || [],
        ),
      );
    }
  }, [
    selectedNode?.data?.gaiaWebsiteDatasources,
    user.customer.gaiaWebsiteDatasources,
  ]);

  const [file, setFile] = useState(null);
  const [isConvertCompressDialogOpen, setIsConvertCompressDialogOpen] =
    useState(false);
  const [shouldUpload, setShouldUpload] = useState(false);
  const [isCompressing, setIsCompressing] = useState(false);
  const [selectedNodeConvertCompress, setSelectedNodeConvertCompress] =
    useState(null);

  useEffect(() => {
    if (
      file &&
      !isConvertCompressDialogOpen &&
      shouldUpload &&
      selectedNodeConvertCompress &&
      selectedNodeConvertCompress !== undefined
    ) {
      const nodeToUpload = nodes.find(
        (n) => n.id === selectedNodeConvertCompress.id,
      );
      const selectedHeaderType = file.type === "video/mp4" ? "video" : "image";
      setShouldUpload(false);
      handleUploadFile({
        file: file,
        setIsUploading: setIsUploading,
        user: user,
        selectedNode: nodeToUpload,
        nodes: nodes,
        setHeaderImageLink: setHeaderImageLink,
        setHeaderVideoLink: setHeaderVideoLink,
        setNodes: setNodes,
        setCards: setCards,
        setModifications: setModifications,
        carouselCardIndex: carouselCardIndex,
        carouselComponentIndex: carouselComponentIndex,
        selectedHeader: selectedHeaderType,
      })
        .then(() => {
          setSelectedNodeConvertCompress(null);
          setCarouselCardIndex(null);
          setCarouselComponentIndex(null);
        })
        .catch((error) => {
          console.error("Error in handleUploadFile:", error);
          setSelectedNodeConvertCompress(null);
          setCarouselCardIndex(null);
          setCarouselComponentIndex(null);
        });
    }
  }, [
    file,
    isConvertCompressDialogOpen,
    shouldUpload,
    selectedNodeConvertCompress,
  ]);

  return (
    <>
      <DialogConvertCompressFile
        isConvertCompressDialogOpen={isConvertCompressDialogOpen}
        setIsConvertCompressDialogOpen={setIsConvertCompressDialogOpen}
        file={file}
        setFile={setFile}
        setShouldUpload={setShouldUpload}
        setIsPanelOpened={setIsPanelOpened}
        isCompressing={isCompressing}
        setIsCompressing={setIsCompressing}
        setSelectedNodeConvertCompress={setSelectedNodeConvertCompress}
        setCarouselCardIndex={setCarouselCardIndex}
        setCarouselComponentIndex={setCarouselComponentIndex}
      />
      <Transition show={activeErrorSubmitting ? false : isPanelOpened}>
        <Dialog
          className="z-50 relative"
          style={{ zIndex: "999999998" }}
          onClose={setIsPanelOpened}
        >
          <TransitionChild
            enter="ease-in duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-75"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-10 transition-opacity" />
          </TransitionChild>
          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 m-1">
                <TransitionChild
                  enter="transform transition ease-in-out duration-300"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-100"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <DialogPanel className="pointer-events-auto w-screen max-w-md translate-x-0">
                    <div className="flex h-full h-max-[50vh] flex-col w-full overflow-x-hidden bg-white shadow-xl rounded-lg absolute">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <div className="absolute top-5 -left-10 ml-3 flex h- items-center">
                            <button
                              type="button"
                              className="relative z-10 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
                              onClick={() => {
                                setIsPanelOpened(false);
                              }}
                            >
                              <span className="absolute -inset-2.5" />
                              <span className="sr-only">Close panel</span>
                              <XMarkIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6 overflow-y-auto thin-scrollbar ">
                        <InnerPanel
                          api={api}
                          selectedNode={selectedNode}
                          nodes={nodes}
                          setNodes={setNodes}
                          TagAutocompleteCondition={TagAutocompleteCondition}
                          edges={edges}
                          setEdges={setEdges}
                          user={user}
                          isLoading={isLoading}
                          isSubmitLoading={isSubmitLoading}
                          isUploading={isUploading}
                          setIsUploading={setIsUploading}
                          isEmojiPickerVisible={isEmojiPickerVisible}
                          setIsEmojiPickerVisible={setIsEmojiPickerVisible}
                          templates={templates}
                          templatesByName={templatesByName}
                          isPanelOpened={isPanelOpened}
                          setIsPanelOpened={setIsPanelOpened}
                          integrations={integrations}
                          scenario={scenario}
                          setModifications={setModifications}
                          templateName={templateName}
                          setTemplateName={setTemplateName}
                          selectedCategory={selectedCategory}
                          setSelectedCategory={setSelectedCategory}
                          selectedHeader={selectedHeader}
                          setSelectedHeader={setSelectedHeader}
                          selectedCardsHeader={selectedCardsHeader}
                          setSelectedCardsHeader={setSelectedCardsHeader}
                          isLimitedTimeOffer={isLimitedTimeOffer}
                          setIsLimitedTimeOffer={setIsLimitedTimeOffer}
                          limitedTimeOffer={limitedTimeOffer}
                          setLimitedTimeOffer={setLimitedTimeOffer}
                          cards={cards}
                          setCards={setCards}
                          body={body}
                          setBody={setBody}
                          footer={footer}
                          setFooter={setFooter}
                          numberOfQuickReplies={numberOfQuickReplies}
                          setNumberOfQuickReplies={setNumberOfQuickReplies}
                          copyCodeButton={copyCodeButton}
                          setCopyCodeButton={setCopyCodeButton}
                          quickReply1={quickReply1}
                          setQuickReply1={setQuickReply1}
                          quickReply2={quickReply2}
                          setQuickReply2={setQuickReply2}
                          quickReply3={quickReply3}
                          setQuickReply3={setQuickReply3}
                          replyButtons={replyButtons}
                          setReplyButtons={setReplyButtons}
                          urlButton={urlButton}
                          urlButton2={urlButton2}
                          numberOfUrl={numberOfUrl}
                          setNumberOfUrl={setNumberOfUrl}
                          setUrlButton={setUrlButton}
                          urlButtonLink={urlButtonLink}
                          setUrlButtonLink={setUrlButtonLink}
                          setUrlButton2={setUrlButton2}
                          urlButtonLink2={urlButtonLink2}
                          setUrlButtonLink2={setUrlButtonLink2}
                          isUrlButtonAtBottom={isUrlButtonAtBottom}
                          setIsUrlButtonAtBottom={setIsUrlButtonAtBottom}
                          bodyParameters={bodyParameters}
                          setBodyParameters={setBodyParameters}
                          headerImageLink={headerImageLink}
                          setHeaderImageLink={setHeaderImageLink}
                          headerVideoLink={headerVideoLink}
                          setHeaderVideoLink={setHeaderVideoLink}
                          messageErrors={messageErrors}
                          templateNameError={templateNameError}
                          setTemplateNameError={setTemplateNameError}
                          bodyErrorMsg={bodyErrorMsg}
                          setBodyErrorMsg={setBodyErrorMsg}
                          quickReply1ErrorMsg={quickReply1ErrorMsg}
                          setQuickReply1ErrorMsg={setQuickReply1ErrorMsg}
                          quickReply2ErrorMsg={quickReply2ErrorMsg}
                          setQuickReply2ErrorMsg={setQuickReply2ErrorMsg}
                          quickReply3ErrorMsg={quickReply3ErrorMsg}
                          setQuickReply3ErrorMsg={setQuickReply3ErrorMsg}
                          urlButtonErrorMsg={urlButtonErrorMsg}
                          setUrlButtonErrorMsg={setUrlButtonErrorMsg}
                          urlButtonLinkErrorMsg={urlButtonLinkErrorMsg}
                          setUrlButtonLinkErrorMsg={setUrlButtonLinkErrorMsg}
                          urlButton2ErrorMsg={urlButton2ErrorMsg}
                          setUrlButton2ErrorMsg={setUrlButton2ErrorMsg}
                          urlButtonLink2ErrorMsg={urlButtonLink2ErrorMsg}
                          setUrlButtonLink2ErrorMsg={setUrlButtonLink2ErrorMsg}
                          limitedTimeOfferTextError={limitedTimeOfferTextError}
                          setLimitedTimeOfferTextError={
                            setLimitedTimeOfferTextError
                          }
                          customField1ErrorMsg={customField1ErrorMsg}
                          setCustomField1ErrorMsg={setCustomField1ErrorMsg}
                          customField2ErrorMsg={customField2ErrorMsg}
                          setCustomField2ErrorMsg={setCustomField2ErrorMsg}
                          customField3ErrorMsg={customField3ErrorMsg}
                          setCustomField3ErrorMsg={setCustomField3ErrorMsg}
                          bodyCardErrors={bodyCardErrors}
                          setBodyCardErrors={setBodyCardErrors}
                          buttonCardErrors={buttonCardErrors}
                          setButtonCardErrors={setButtonCardErrors}
                          templateNameRef={templateNameRef}
                          bodyRef={bodyRef}
                          quickReply1Ref={quickReply1Ref}
                          quickReply2Ref={quickReply2Ref}
                          quickReply3Ref={quickReply3Ref}
                          urlButtonLinkRef={urlButtonLinkRef}
                          urlButtonLink2Ref={urlButtonLink2Ref}
                          bodyCardRefs={bodyCardRefs}
                          buttonCardRefs={buttonCardRefs}
                          campaignId={campaignId}
                          gaiaWebsiteDatasources={gaiaWebsiteDatasources}
                          setGaiaWebsiteDatasources={setGaiaWebsiteDatasources}
                          handleConvertToAnswer={handleConvertToAnswer}
                          handleOpenProductPicker={handleOpenProductPicker}
                          shopifyUpsellLineItems={shopifyUpsellLineItems}
                          setShopifyUpsellLineItems={setShopifyUpsellLineItems}
                          setFile={setFile}
                          setIsConvertCompressDialogOpen={
                            setIsConvertCompressDialogOpen
                          }
                          handleUploadFile={handleUploadFile}
                          carouselCardIndex={carouselCardIndex}
                          setCarouselCardIndex={setCarouselCardIndex}
                          carouselComponentIndex={carouselComponentIndex}
                          setCarouselComponentIndex={setCarouselComponentIndex}
                          selectedNodeConvertCompress={
                            selectedNodeConvertCompress
                          }
                          setSelectedNodeConvertCompress={
                            setSelectedNodeConvertCompress
                          }
                          isCompressing={isCompressing}
                        />
                      </div>
                      <>
                        <Divider />
                        <div className="flex flex-shrink-0 justify-end px-4 py-4">
                          {selectedNode?.data?.isEditing ? (
                            <>
                              <Button
                                color="secondaryButton"
                                disabled={
                                  selectedNode.data.isCancelable === false ||
                                  isSubmitLoading
                                }
                                onClick={async () => {
                                  const canceledData = {
                                    ...selectedNode.data,
                                  };
                                  if (selectedNode.data.oldData) {
                                    const oldData = {
                                      ...selectedNode.data.oldData,
                                    };

                                    const {
                                      limitedTimeOffer: _limitedTimeOffer,
                                      copyCodeButton: _copyCodeButton,
                                      bodyParameters: _bodyParameters,
                                      headerParameters: _headerParameters,
                                      urlButton: _urlButton,
                                      urlButton2: _urlButton2,
                                      cards: _cards,
                                      whatsappTemplateName:
                                        _whatsappTemplateName,
                                    } = oldData;

                                    if (_urlButton) {
                                      delete _urlButton.gadgetId;
                                    }

                                    if (_urlButton2) {
                                      delete _urlButton2.gadgetId;
                                    }

                                    handleTemplateSelectionChange({
                                      value: _whatsappTemplateName,
                                      nodes,
                                      setNodes,
                                      templates,
                                      templatesByName,
                                      api,
                                      urlButton,
                                      urlButton2,
                                    });

                                    if (_bodyParameters) {
                                      handleMessageChange(
                                        "bodyParameters",
                                        _bodyParameters,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }
                                    if (_headerParameters) {
                                      handleMessageChange(
                                        "headerParameters",
                                        _headerParameters,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }
                                    if (_limitedTimeOffer) {
                                      handleMessageChange(
                                        "limitedTimeOffer",
                                        _limitedTimeOffer,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }
                                    if (_copyCodeButton) {
                                      handleMessageChange(
                                        "copyCodeButton",
                                        _copyCodeButton,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }

                                    if (_cards) {
                                      const sanitizedCards = {
                                        ..._cards,
                                        cards: _cards.map((card) => {
                                          return {
                                            ...card,
                                            components: card.components.map(
                                              (component) => {
                                                if (
                                                  component.type ===
                                                    "BUTTONS" &&
                                                  Array.isArray(
                                                    component.buttons,
                                                  )
                                                ) {
                                                  const sanitizedButtons =
                                                    component.buttons.map(
                                                      (button) => {
                                                        // Déstructure et élimine les clés indésirables
                                                        // prettier-ignore
                                                        // eslint-disable-next-line no-unused-vars
                                                        const { gadgetId, ...rest } = button;
                                                        return rest;
                                                      },
                                                    );
                                                  return {
                                                    ...component,
                                                    buttons: sanitizedButtons,
                                                  };
                                                }
                                                return component;
                                              },
                                            ),
                                          };
                                        }),
                                      };

                                      handleMessageChange(
                                        "cards",
                                        sanitizedCards.cards,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }

                                    setTemplateNameError("");
                                    setBodyErrorMsg("");
                                    setQuickReply1ErrorMsg("");
                                    setQuickReply2ErrorMsg("");
                                    setQuickReply3ErrorMsg("");
                                    setUrlButtonErrorMsg("");
                                    setUrlButtonLinkErrorMsg("");
                                    setUrlButton2ErrorMsg("");
                                    setUrlButtonLink2ErrorMsg("");
                                    setLimitedTimeOfferTextError("");
                                    setCustomField1ErrorMsg("");
                                    setCustomField2ErrorMsg("");
                                    setCustomField3ErrorMsg("");
                                    setBodyCardErrors([]);
                                    setButtonCardErrors([]);

                                    selectedNode.data.shouldBeReplaced = false;
                                    selectedNode.data.isEditing = false;
                                    const selectedTemplate = Object.values(
                                      templates,
                                    ).find(
                                      (template) =>
                                        template.name ===
                                        selectedNode.data?.oldData
                                          ?.whatsappTemplateName,
                                    );

                                    handleShouldBeReplaced(
                                      true,
                                      nodes,
                                      edges,
                                      selectedTemplate,
                                      setNodes,
                                      setEdges,
                                      api,
                                      canceledData,
                                    );
                                  } else {
                                    if (canceledData) {
                                      handleMessageChange(
                                        "oldData",
                                        canceledData,
                                        nodes,
                                        setNodes,
                                        selectedNode,
                                      );
                                    }
                                    Object.keys(selectedNode.data).forEach(
                                      (key) => {
                                        if (
                                          key !== "isEditing" &&
                                          key !== "clickNode" &&
                                          key !== "isTemplate" &&
                                          key !== "nodeId"
                                        ) {
                                          selectedNode.data[key] = null;
                                        }
                                      },
                                    );
                                    selectedNode.data.shouldBeReplaced = true;
                                    selectedNode.data.isEditing = false;
                                    selectedNode.data.whatsappTemplateName = "";
                                    selectedNode.data.urlClickRate = 0;
                                    selectedNode.data.buttons = [];

                                    setTemplateName("");
                                    setSelectedCategory(
                                      WhatsappTemplateCategoryEnum.UTILITY,
                                    );
                                    setLimitedTimeOffer(null);
                                    setIsLimitedTimeOffer(false);
                                    setCards(null);
                                    setBody("");
                                    setFooter("");
                                    setNumberOfQuickReplies(0);
                                    setCopyCodeButton(null);
                                    setQuickReply1("");
                                    setQuickReply2("");
                                    setQuickReply3("");
                                    setReplyButtons([]);
                                    setNumberOfUrl(0);
                                    setUrlButton("");
                                    setUrlButtonLink("");
                                    setUrlButton2("");
                                    setUrlButtonLink2("");

                                    setTemplateNameError("");
                                    setBodyErrorMsg("");
                                    setQuickReply1ErrorMsg("");
                                    setQuickReply2ErrorMsg("");
                                    setQuickReply3ErrorMsg("");
                                    setUrlButtonErrorMsg("");
                                    setUrlButtonLinkErrorMsg("");
                                    setUrlButton2ErrorMsg("");
                                    setUrlButtonLink2ErrorMsg("");
                                    setLimitedTimeOfferTextError("");
                                    setCustomField1ErrorMsg("");
                                    setCustomField2ErrorMsg("");
                                    setCustomField3ErrorMsg("");
                                    setBodyCardErrors([]);
                                    setButtonCardErrors([]);

                                    const edgesToDelete = edges.filter(
                                      (e) =>
                                        e.source === selectedNode.id &&
                                        e.sourceHandle !== "main" &&
                                        e.sourceHandle !== "",
                                    );
                                    for (const e of edgesToDelete) {
                                      await deleteEdge(e, setEdges, api, edges);
                                    }
                                  }
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                className="ml-3"
                                color="primaryButton"
                                loading={isSubmitLoading}
                                onClick={async () => {
                                  setIsSubmitLoading(true);
                                  setSubmitedNode({ ...selectedNode });

                                  const currentNode = nodes.find(
                                    (n) => n.id === selectedNode.id,
                                  );
                                  setNodes((nds) =>
                                    nds.map((node) => {
                                      if (node.id === currentNode.id) {
                                        node.data = {
                                          ...node.data,
                                          isPending: true,
                                          isCancelable: true,
                                          hasFailed: false,
                                        };
                                      }
                                      return node;
                                    }),
                                  );

                                  let urlButtonLinkToSend = urlButtonLink;

                                  if (urlButtonLink && urlButtonLink !== "") {
                                    urlButtonLinkToSend = urlButtonLink
                                      .trim()
                                      .startsWith("http")
                                      ? urlButtonLink.trim()
                                      : `http://${urlButtonLink.trim()}`;

                                    urlButtonLinkToSend =
                                      urlButtonLinkToSend.replace(
                                        /\{\{[^}]+\}\}/g,
                                        "{{1}}",
                                      );
                                  }

                                  let urlButtonLink2ToSend = urlButtonLink2;

                                  if (urlButtonLink2 && urlButtonLink2 !== "") {
                                    urlButtonLink2ToSend = urlButtonLink2
                                      .trim()
                                      .startsWith("http")
                                      ? urlButtonLink2.trim()
                                      : `http://${urlButtonLink2.trim()}`;

                                    urlButtonLink2ToSend =
                                      urlButtonLink2ToSend.replace(
                                        /\{\{[^}]+\}\}/g,
                                        "{{1}}",
                                      );
                                  }

                                  const submitSuccess = await submitTemplate({
                                    isInPanel: true,
                                    templateName,
                                    limitedTimeOffer,
                                    isLimitedTimeOffer,
                                    body,
                                    cards: selectedNode.data.cards,
                                    footer,
                                    flowButton: selectedNode.data.flowButton,
                                    urlButton,
                                    urlButtonLink: urlButtonLinkToSend,
                                    urlButton2,
                                    urlButtonLink2: urlButtonLink2ToSend,
                                    urlButtonTrackingEnabled:
                                      selectedNode.data.urlButton
                                        ?.trackingEnabled,
                                    urlButton2TrackingEnabled:
                                      selectedNode.data.urlButton2
                                        ?.trackingEnabled,
                                    copyCodeButton,
                                    quickReply1,
                                    quickReply2,
                                    quickReply3,
                                    numberOfQuickReplies,
                                    numberOfUrl,
                                    replyButtons,
                                    isUrlButtonAtBottom,
                                    selectedHeader,
                                    selectedCategory,
                                    headerImageLink: headerImageLink,
                                    headerVideoLink: headerVideoLink,
                                    user,
                                    setNewTemplateName,
                                    setIsSubmitLoading,
                                    toggleActiveSumbit,
                                    templateNameRef,
                                    bodyRef,
                                    quickReply1Ref,
                                    quickReply2Ref,
                                    quickReply3Ref,
                                    urlButtonLinkRef,
                                    urlButtonLink2Ref,
                                    bodyCardRefs,
                                    buttonCardRefs,
                                    errorSetters: {
                                      setTemplateNameError,
                                      setBodyErrorMsg,
                                      setQuickReply1ErrorMsg,
                                      setQuickReply2ErrorMsg,
                                      setQuickReply3ErrorMsg,
                                      setUrlButtonErrorMsg,
                                      setUrlButtonLinkErrorMsg,
                                      setUrlButton2ErrorMsg,
                                      setUrlButtonLink2ErrorMsg,
                                      setLimitedTimeOfferTextError,
                                      setCustomField1ErrorMsg,
                                      setCustomField2ErrorMsg,
                                      setCustomField3ErrorMsg,
                                      setBodyCardErrors,
                                      setButtonCardErrors,
                                    },
                                  });
                                  console.log(submitSuccess);
                                  setIsSubmitLoading(false);

                                  if (submitSuccess.success) {
                                    setIsPanelOpened(false);
                                    setNodes((nds) =>
                                      nds.map((node) => {
                                        if (node.id === currentNode.id) {
                                          node.data = {
                                            ...node.data,
                                            isEditing: false,
                                            hasFailed: false,
                                            isCancelable: true,
                                          };
                                        }
                                        return node;
                                      }),
                                    );
                                  } else {
                                    if (submitSuccess.error) {
                                      setErrorMessage(submitSuccess.error);
                                      toggleActiveErrorSumbitting();
                                    }
                                    setNodes((nds) =>
                                      nds.map((node) => {
                                        if (node.id === currentNode.id) {
                                          node.data = {
                                            ...node.data,
                                            isPending: false,
                                            isEditing: true,
                                          };
                                        }
                                        return node;
                                      }),
                                    );
                                  }
                                  console.log("node to check", currentNode);
                                }}
                              >
                                Submit
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                color="secondaryButton"
                                disabled={
                                  selectedNode?.data?.isTemplate ||
                                  selectedNode?.deletable === false
                                }
                                onClick={() => {
                                  deleteElements({ nodes: [selectedNode] });
                                }}
                              >
                                Delete
                              </Button>
                              <Button
                                className="ml-3"
                                color="primaryButton"
                                onClick={() => {
                                  const isValid = checkData();
                                  if (isValid) {
                                    setIsPanelOpened(false);
                                  }
                                }}
                              >
                                OK
                              </Button>
                            </>
                          )}
                        </div>
                      </>
                    </div>
                  </DialogPanel>
                </TransitionChild>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>

      <DialogConvertAnswer
        data={dialogConvertAnswerData}
        setData={setDialogConvertAnswerData}
        nodes={nodes}
        setNodes={setNodes}
        edges={edges}
        scenario={scenario}
        campaignId={campaignId}
        campaignName={scenario?.name}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsEditingInput={setIsPanelOpened}
        setModifications={setModifications}
      />

      <TailwindDialog
        open={productPickerDialogData.isModalOpen}
        onClose={() => {
          setProductPickerDialogData((prev) => ({
            ...prev,
            isModalOpen: false,
          }));
          setIsPanelOpened(true);
          // Scroll to bottom of panel after modal closes
          setTimeout(() => {
            const panelElement = document.querySelector(
              ".overflow-y-auto.thin-scrollbar",
            );
            if (panelElement) {
              panelElement.scrollTop = panelElement.scrollHeight;
            }
          }, 100);
        }}
        size="6xl"
        className="h-[90vh]"
      >
        <TailwindDialogTitle>Select Products for Upsell</TailwindDialogTitle>
        <ProductPicker
          onSelectionChange={(selectedVariants) => {
            const lineItems = selectedVariants.map((variant) => ({
              variantId: variant.id,
              quantity: variant.quantity || 1,
              price: variant.price,
              title: variant.title,
              productTitle: variant.product?.title,
              currency: variant.shop?.currency,
            }));
            setShopifyUpsellLineItems(lineItems);
            setModifications(true);
            handleMessageChange(
              "shopifyUpsellLineItems",
              lineItems,
              nodes,
              setNodes,
              selectedNode,
            );
          }}
          selectedVariants={
            shopifyUpsellLineItems?.map((item) => ({
              id: item.variantId,
              quantity: item.quantity,
              price: item.price,
              title: item.title,
              product: { title: item.productTitle },
              shop: { currency: item.currency },
            })) || []
          }
          onCreateDraftOrder={(selectedData) => {
            const lineItems = selectedData.map((variant) => ({
              variantId: variant.variantId,
              quantity: variant.quantity || 1,
              price: variant.price,
              title: variant.variantTitle,
              productTitle: variant.productTitle,
              currency: variant.currency,
            }));
            setShopifyUpsellLineItems(lineItems);
            setModifications(true);
            handleMessageChange(
              "shopifyUpsellLineItems",
              lineItems,
              nodes,
              setNodes,
              selectedNode,
            );
            setProductPickerDialogData((prev) => ({
              ...prev,
              isModalOpen: false,
            }));
            setIsPanelOpened(true);
            // Scroll to bottom of panel after modal closes
            setTimeout(() => {
              const panelElement = document.querySelector(
                ".overflow-y-auto.thin-scrollbar",
              );
              if (panelElement) {
                panelElement.scrollTop = panelElement.scrollHeight;
              }
            }, 100);
          }}
        />
      </TailwindDialog>

      <TailwindDialog
        open={activeErrorSubmitting}
        onClose={() => {
          setIsPanelOpened(true);
          toggleActiveErrorSumbitting;
        }}
        className="z-60 relative"
        style={{ zIndex: "999999999" }}
      >
        <TailwindDialogTitle close={false}>
          Template could not be submitted for verification.
        </TailwindDialogTitle>
        <TailwindDialogBody>
          <Text>
            <b>{templateName}</b> has not been submitted to Meta.
          </Text>
          <Text>
            👇 Try to solve the issue with the message below or contact support
          </Text>
          <br />
          <br />
          <Text fontWeight="bold">Error message:</Text>
          {errorMessage !== "" && (
            <ExtractUserMessage fullError={errorMessage} />
          )}
        </TailwindDialogBody>
        <TailwindDialogActions>
          <Button
            color="primaryButton"
            onClick={async () => {
              setIsPanelOpened(true);
              toggleActiveErrorSumbitting();
            }}
          >
            OK
          </Button>
        </TailwindDialogActions>
      </TailwindDialog>
    </>
  );
};

const InnerPanel = ({
  api,
  selectedNode,
  nodes,
  setNodes,
  TagAutocompleteCondition,
  edges,
  setEdges,
  user,
  isLoading,
  isSubmitLoading,
  isUploading,
  setIsUploading,
  templates,
  templatesByName,
  isPanelOpened,
  setIsPanelOpened,
  integrations,
  scenario,
  setModifications,
  templateName,
  setTemplateName,
  selectedCategory,
  setSelectedCategory,
  selectedHeader,
  setSelectedHeader,
  selectedCardsHeader,
  setSelectedCardsHeader,
  isLimitedTimeOffer,
  setIsLimitedTimeOffer,
  limitedTimeOffer,
  setLimitedTimeOffer,
  cards,
  setCards,
  body,
  setBody,
  footer,
  setFooter,
  numberOfQuickReplies,
  setNumberOfQuickReplies,
  copyCodeButton,
  setCopyCodeButton,
  quickReply1,
  setQuickReply1,
  quickReply2,
  setQuickReply2,
  quickReply3,
  setQuickReply3,
  replyButtons,
  setReplyButtons,
  urlButton,
  numberOfUrl,
  setNumberOfUrl,
  setUrlButton,
  urlButtonLink,
  setUrlButtonLink,
  urlButton2,
  setUrlButton2,
  urlButtonLink2,
  setUrlButtonLink2,
  isUrlButtonAtBottom,
  setIsUrlButtonAtBottom,
  bodyParameters,
  setBodyParameters,
  headerImageLink,
  setHeaderImageLink,
  headerVideoLink,
  setHeaderVideoLink,
  messageErrors,
  templateNameError,
  setTemplateNameError,
  bodyErrorMsg,
  setBodyErrorMsg,
  quickReply1ErrorMsg,
  setQuickReply1ErrorMsg,
  quickReply2ErrorMsg,
  setQuickReply2ErrorMsg,
  quickReply3ErrorMsg,
  setQuickReply3ErrorMsg,
  urlButtonErrorMsg,
  setUrlButtonErrorMsg,
  urlButtonLinkErrorMsg,
  setUrlButtonLinkErrorMsg,
  urlButton2ErrorMsg,
  setUrlButton2ErrorMsg,
  urlButtonLink2ErrorMsg,
  setUrlButtonLink2ErrorMsg,
  limitedTimeOfferTextError,
  setLimitedTimeOfferTextError,
  customField1ErrorMsg,
  setCustomField1ErrorMsg,
  customField2ErrorMsg,
  setCustomField2ErrorMsg,
  customField3ErrorMsg,
  setCustomField3ErrorMsg,
  bodyCardErrors,
  setBodyCardErrors,
  buttonCardErrors,
  setButtonCardErrors,
  templateNameRef,
  bodyRef,
  quickReply1Ref,
  quickReply2Ref,
  quickReply3Ref,
  urlButtonLinkRef,
  urlButtonLink2Ref,
  bodyCardRefs,
  buttonCardRefs,
  campaignId,
  gaiaWebsiteDatasources,
  setGaiaWebsiteDatasources,
  handleConvertToAnswer,
  handleOpenProductPicker,
  shopifyUpsellLineItems,
  setShopifyUpsellLineItems,
  setFile,
  setIsConvertCompressDialogOpen,
  handleUploadFile,
  carouselCardIndex,
  setCarouselCardIndex,
  carouselComponentIndex,
  setCarouselComponentIndex,
  isCompressing,
  selectedNodeConvertCompress,
  setSelectedNodeConvertCompress,
}) => {
  const handleTypeChange = (newType, nodes) => {
    const updatedNodes = [...nodes];
    const selectedNode = updatedNodes.find((n) => n.selected);
    selectedNode.data.type = newType;
    setNodes(updatedNodes);
  };

  const handleButtonChange = (index, newValue, nodes, property = "title") => {
    const updatedNodes = [...nodes];
    const selectedNode = updatedNodes.find((n) => n.selected);
    selectedNode.data.buttons[index][property] = newValue;
    setNodes(updatedNodes);
  };

  const handleTagMessageChange = useCallback(
    (selectedTag) => {
      handleMessageChange(
        "tag",
        selectedTag.label,
        nodes,
        setNodes,
        selectedNode,
      );
      handleMessageChange(
        "tagId",
        selectedTag.id,
        nodes,
        setNodes,
        selectedNode,
      );
    },
    [nodes, setNodes, selectedNode],
  );

  const editTemplate = () => {
    selectedNode.data.shouldBeReplaced = true;
    selectedNode.data.whatsappTemplateId = "";
    selectedNode.data.messageSkeletonId = "";
    selectedNode.data.isPending = false;
    selectedNode.data.hasFailed = false;

    setTemplateName(selectedNode.data.whatsappTemplateName ?? "");

    const {
      category,
      limitedTimeOffer: _limitedTimeOffer,
      cards: _cards,
    } = selectedNode.data;

    const _isLimitedTimeOffer =
      category === WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER &&
      _limitedTimeOffer;
    if (_isLimitedTimeOffer) {
      setSelectedCategory(WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER);
      setFooter("");
      if (numberOfUrl === 0) {
        setNumberOfUrl((n) => n + 1);
      }
      setLimitedTimeOffer({ ..._limitedTimeOffer });
      setCards(null);
    } else if (_cards) {
      setSelectedCategory(WhatsappTemplateCategoryEnum.CAROUSEL);
      setFooter("");
      setSelectedCardsHeader(
        selectedNode?.data?.cards[0]?.components?.find(
          (c) => c.type === "HEADER",
        )?.format === "IMAGE"
          ? ["image"]
          : ["video"],
      );
      setNumberOfUrl(0);
      setNumberOfQuickReplies(0);
      setLimitedTimeOffer(null);
      setUrlButton(null);
      setUrlButton2(null);
      const sanitizedCards = {
        ..._cards,
        cards: _cards.map((card) => {
          return {
            ...card,
            components: card.components.map((component) => {
              if (
                component.type === "BUTTONS" &&
                Array.isArray(component.buttons)
              ) {
                const sanitizedButtons = component.buttons.map((button) => {
                  // Déstructure et élimine les clés indésirables
                  // prettier-ignore
                  // eslint-disable-next-line no-unused-vars
                  const { gadgetId, clicks, replyButtonId, redirectionUrlId, redirectionUrlUuid,

                    ...rest
                  } = button;
                  return rest;
                });
                return { ...component, buttons: sanitizedButtons };
              }
              return component;
            }),
          };
        }),
      };

      setCards(sanitizedCards.cards);
      handleMessageChange(
        "cards",
        sanitizedCards.cards,
        nodes,
        setNodes,
        selectedNode,
      );
    } else {
      setSelectedHeader([selectedNode?.data?.headerParameters?.type ?? "none"]);
      setSelectedCategory(category);
      setFooter(selectedNode.data.footer ?? "");
      setNumberOfUrl(
        selectedNode.data.urlButton
          ? selectedNode.data.urlButton2
            ? 2
            : 1
          : 0,
      );
      setLimitedTimeOffer(null);
      setCards(null);
    }

    setIsLimitedTimeOffer(_isLimitedTimeOffer);
    setSelectedHeader([selectedNode?.data?.headerParameters?.type ?? "none"]);
    setHeaderImageLink(
      selectedNode.data.headerParameters?.image === "shopifyProductImage"
        ? ""
        : selectedNode.data.headerParameters?.image?.link || "",
    );
    setHeaderVideoLink(selectedNode.data.headerParameters?.video?.link || "");
    const bodyContent = selectedNode.data.body;

    const sanitizedBody =
      bodyContent && bodyContent.replace(/\n+$/, "").trim() !== ""
        ? bodyContent.replace(/\n+$/, "")
        : null;

    setBody(sanitizedBody ?? "");
    setNumberOfQuickReplies(selectedNode.data.buttons?.length ?? "");
    setCopyCodeButton(selectedNode?.data?.copyCodeButton);
    setQuickReply1(selectedNode?.data?.buttons?.[0]?.title ?? "");
    setQuickReply2(selectedNode?.data?.buttons?.[1]?.title ?? "");
    setQuickReply3(selectedNode?.data?.buttons?.[2]?.title ?? "");
    setReplyButtons(selectedNode?.data?.buttons || []);
    setUrlButton(selectedNode.data.urlButton?.text ?? "");
    setUrlButtonLink(selectedNode.data.urlButton?.url ?? "");
    setUrlButton2(selectedNode.data.urlButton2?.text ?? "");
    setUrlButtonLink2(selectedNode.data.urlButton2?.url ?? "");
    setIsUrlButtonAtBottom(selectedNode.data.isUrlButtonAtBottom ?? "");
    setShopifyUpsellLineItems(selectedNode.data.shopifyUpsellLineItems ?? []);
  };

  const [isSimioApiKeyVisible, setIsSimioApiKeyVisible] = useState(false);
  const [isTemplateChanged, setIsTemplateChanged] = useState(false);
  const [prevNode, setPrevNode] = useState(null);

  useEffect(() => {
    if (
      selectedNode?.data?.isEditing &&
      isPanelOpened &&
      isLoading &&
      !isSubmitLoading
    ) {
      editTemplate();
    }
  }, [selectedNode?.data?.isEditing]);

  const getCleanedNode = (node) => {
    if (!node || !node.data) return node;
    // eslint-disable-next-line no-unused-vars
    const { oldData, ...cleanedData } = node.data;
    return JSON.parse(JSON.stringify({ ...node, data: cleanedData }));
  };

  useEffect(() => {
    if (selectedNode?.data?.isEditing && isPanelOpened) {
      editTemplate();
    }
  }, [selectedNode?.data?.isEditing]);

  useEffect(() => {
    if (!isPanelOpened && isTemplateChanged && !selectedNode?.data.isEditing) {
      let selectedTemplate;
      if (templates) {
        selectedTemplate = templates.find(
          (t) => t.name === selectedNode?.data.whatsappTemplateName,
        );
        handleShouldBeReplaced(
          true,
          nodes,
          edges,
          selectedTemplate,
          setNodes,
          setEdges,
          api,
          prevNode?.data,
        );
      }
      setIsTemplateChanged(false);
    } else if (isPanelOpened) {
      setPrevNode(getCleanedNode(selectedNode));
    }
  }, [isPanelOpened]);

  const inputClasses = "mx-1 w-16";
  const timeSectionClasses = "flex items-center";
  const [waitingDay, setWaitingDay] = useState("");
  const [waitingHour, setWaitingHour] = useState("");
  const [waitingMinute, setWaitingMinute] = useState("");
  const [storeAnswer, setStoreAnswer] = useState(false);
  const [storageField, setStorageField] = useState("");

  const setWaitingTime = () => {
    const totalMinutes = selectedNode.data.duration ?? 0;
    const initialDays = Math.floor(totalMinutes / 1440);
    const initialHours = Math.floor((totalMinutes - initialDays * 1440) / 60);
    const initialMinutes =
      totalMinutes - initialDays * 1440 - initialHours * 60;

    setWaitingDay(initialDays);
    setWaitingHour(initialHours);
    setWaitingMinute(initialMinutes);

    // Initialize storage settings
    setStoreAnswer(selectedNode.data.storeAnswer ?? false);
    setStorageField(selectedNode.data.storageField ?? "");
  };

  const [selectedPropertyOption, setSelectedPropertyOption] = useState("");
  const [selectedOperatorOption, setSelectedOperatorOption] = useState("");
  const [selectedBooleanOption, setSelectedBooleanOption] = useState("");

  const [conditionDay, setConditionDay] = useState("");
  const [conditionHour, setConditionHour] = useState("");
  const [conditionMinute, setConditionMinute] = useState("");

  const [unitPercentage, setUnitPercentage] = useState(
    selectedNode?.data?.valuePercentage ?? 0,
  );

  const [headers, setHeaders] = useState(
    selectedNode?.data?.headers !== ""
      ? selectedNode?.data?.headers
      : [{ key: "", value: "" }],
  );
  const [queryParams, setQueryParams] = useState(
    selectedNode?.data?.queryParams !== ""
      ? selectedNode?.data?.queryParams
      : [{ key: "", value: "" }],
  );
  const [pathParams, setPathParams] = useState(
    selectedNode?.data?.pathParams !== ""
      ? selectedNode?.data?.pathParams
      : [{ key: "", value: "" }],
  );
  const [configResponse, setConfigResponse] = useState(
    selectedNode?.data?.configResponse !== ""
      ? selectedNode?.data?.configResponse
      : [{ key: "", value: "" }],
  );
  const [jsonError, setJsonError] = useState(false);
  const [testRequestLoading, setTestRequestLoading] = useState(false);

  const [isSidePanelVariableOpen, setIsSidePanelVariableOpen] = useState(false);
  const [isSidePanelTestOpen, setIsSidePanelTestOpen] = useState(false);
  const [lastContact, setLastContact] = useState(null);
  const [exampleContactPhone, setExampleContactPhone] = useState(null);
  const [exampleContactError, setExampleContactError] = useState(false);
  const [exampleContactLoading, setExampleContactLoading] = useState(false);
  const [responseTestRequest, setResponseTestRequest] = useState(null);
  const [variableCopied, setVariableCopied] = useState(null);

  const textareaJsonBodyRef = useRef(null);

  const validateJson = (input) => {
    try {
      JSON.parse(input);
      setJsonError(false);
    } catch (e) {
      setJsonError(true);
      console.log("error parsing", e);
    }
  };

  const setConditions = () => {
    setSelectedPropertyOption(selectedNode.data.property ?? "");
    setSelectedOperatorOption(selectedNode.data.operator ?? "");

    setSelectedBooleanOption(selectedNode.data.valueBoolean ?? "");

    const totalMinutes = selectedNode.data.valueStartingPeriodInMinutes ?? 0;
    const initialDays = Math.floor(totalMinutes / 1440);
    const initialHours = Math.floor((totalMinutes - initialDays * 1440) / 60);
    const initialMinutes =
      totalMinutes - initialDays * 1440 - initialHours * 60;

    setConditionDay(initialDays);
    setConditionHour(initialHours);
    setConditionMinute(initialMinutes);
  };

  useEffect(() => {
    if (!selectedNode) {
      return;
    }
    switch (selectedNode.type) {
      case "condition":
        setConditions();
        break;
      case "wait":
        setWaitingTime();
        break;
      case "webhook":
        validateJson(selectedNode?.data?.body);
        break;
      case "ai":
        handleMessageChange(
          "gaiaWebsiteDatasources",
          gaiaWebsiteDatasources,
          nodes,
          setNodes,
          selectedNode,
        );
        break;
      default:
        break;
    }
  }, [selectedNode]);

  // Gérer les changements de body pour réinitialiser l'erreur
  useEffect(() => {
    if (selectedNode?.type === "webhook") {
      const body = selectedNode?.data.body;
      if (!body || body === "{}" || body === "{") {
        handleMessageChange("body", "{}", nodes, setNodes, selectedNode);
        setJsonError(false);
      }
    }
  }, [selectedNode?.data?.body]);

  // Panels below

  const { paramOptions, imageParamOptions } = useParameters({
    integrations,
    scenario,
    user,
  });

  if (selectedNode?.type === "consent") {
    const handleConsentChange = () => {
      setNodes((nds) =>
        nds.map((node) => {
          if (node.id === selectedNode.id) {
            // it's important that you create a new object here
            // in order to notify react flow about the change
            node.data = {
              ...node.data,
              type: node.data.type === "optin" ? "optout" : "optin",
            };
          }
          return node;
        }),
      );
    };
    return (
      <>
        <Heading className="text-lg">Contact consent</Heading>
        <Text>
          The contact is{" "}
          {selectedNode.data.type === "optin" ? "added to" : "removed from"}{" "}
          optin base
        </Text>
        <br />
        <Button
          color="secondaryButton"
          onClick={() => handleConsentChange(nodes)}
        >
          {selectedNode.data.type === "optin"
            ? "Switch to Optout"
            : "Switch to Optin"}
        </Button>
      </>
    );
  } else if (selectedNode?.type === "wait") {
    const handleSelectDurationChange = (value, time) => {
      console.log(selectedNode.duration);
      let duration;
      if (time === "day") {
        duration = value * 1440 + waitingHour * 60 + waitingMinute;
      }
      if (time === "hour") {
        duration = waitingDay * 1440 + value * 60 + waitingMinute;
      }
      if (time === "minute") {
        duration = waitingDay * 1440 + waitingHour * 60 + parseInt(value, 10);
      }
      handleMessageChange("duration", duration, nodes, setNodes, selectedNode);
    };
    return (
      <>
        <div className="flex justify-between">
          <Heading className="text-lg">Wait</Heading>
          {selectedNode.data?.type !== "" && (
            <Link
              className="text-gray text-sm hover:underline text-gray-400 cursor-pointer"
              onClick={() => handleTypeChange("", nodes)}
            >
              Change wait type
            </Link>
          )}
        </div>
        {selectedNode.data?.type === "" ? (
          <>
            <Text>
              {
                "The flow is paused until an event has occurred.\n\nEvent selection:"
              }
            </Text>
            <br />
            <div className="grid  grid-cols-3 gap-5">
              <Button
                color="secondaryButton"
                pressed={
                  selectedNode.data.type === "duration" ? "true" : undefined
                }
                onClick={() => handleTypeChange("duration", nodes)}
              >
                Duration
              </Button>
              <Button
                color="secondaryButton"
                pressed={
                  selectedNode.data.type === "whatsapp_message"
                    ? "true"
                    : undefined
                }
                onClick={() => handleTypeChange("whatsapp_message", nodes)}
              >
                Answer
              </Button>
              <Button
                color="secondaryButton"
                pressed={
                  selectedNode.data.type === "whatsapp_message_status"
                    ? "true"
                    : undefined
                }
                onClick={() =>
                  handleTypeChange("whatsapp_message_status", nodes)
                }
              >
                Message read
              </Button>
            </div>
          </>
        ) : selectedNode.data.type === "duration" ? (
          <>
            <Text>Resuming flow after time has elapsed.</Text>
            <Field>
              <Legend>Waiting duration</Legend>
              <Field className="flex items-center justify-between mt-3">
                <div className={timeSectionClasses}>
                  <div className={inputClasses}>
                    <Input
                      value={waitingDay}
                      placeholder={waitingDay === "" ? "0" : waitingDay}
                      type="number"
                      min={0}
                      onChange={(e) => {
                        setWaitingDay(e.target.value);
                        handleSelectDurationChange(e.target.value, "day");
                      }}
                    />
                  </div>
                  <Label>{waitingDay > 1 ? "days" : "day"}</Label>
                </div>

                <div className={timeSectionClasses}>
                  <div className={inputClasses}>
                    <Input
                      value={waitingHour}
                      placeholder={waitingHour === "" ? "0" : waitingHour}
                      type="number"
                      max={23}
                      min={0}
                      onChange={(e) => {
                        setWaitingHour(e.target.value);
                        handleSelectDurationChange(e.target.value, "hour");
                      }}
                    />
                  </div>
                  <Label>{waitingHour > 1 ? "hours" : "hour"}</Label>
                </div>
                <div className={timeSectionClasses}>
                  <div className={inputClasses}>
                    <Input
                      value={waitingMinute}
                      type="number"
                      max={59}
                      min={0}
                      placeholder={waitingMinute === "" ? "0" : waitingMinute}
                      onChange={(e) => {
                        setWaitingMinute(e.target.value);
                        handleSelectDurationChange(e.target.value, "minute");
                      }}
                    />
                  </div>
                  <Label>{waitingMinute > 1 ? "minutes" : "minute"}</Label>
                </div>
              </Field>
            </Field>
          </>
        ) : selectedNode.data.type === "whatsapp_message" ? (
          <>
            <Text>
              Resuming flow as soon as a message is sent by the contact.
            </Text>
            <br />
            <Field>
              <div className="flex items-center justify-between">
                <Label>Store the answer</Label>
                <SwitchOnOff
                  checked={storeAnswer}
                  onChange={(value) => {
                    setStoreAnswer(value);
                    handleMessageChange(
                      "storeAnswer",
                      value,
                      nodes,
                      setNodes,
                      selectedNode,
                    );
                    if (!value) {
                      setStorageField("");
                      handleMessageChange(
                        "storageField",
                        "",
                        nodes,
                        setNodes,
                        selectedNode,
                      );
                    }
                  }}
                />
              </div>
            </Field>
            {storeAnswer && (
              <>
                <br />
                <Field>
                  <Label>Select field</Label>
                  <Select
                    value={storageField}
                    onChange={(e) => {
                      const value = e.target.value;
                      setStorageField(value);
                      handleMessageChange(
                        "storageField",
                        value,
                        nodes,
                        setNodes,
                        selectedNode,
                      );
                    }}
                  >
                    <option value="">Select a field</option>
                    <optgroup label="Contact">
                      <option value="contact.firstName">First Name</option>
                      <option value="contact.lastName">Last Name</option>
                    </optgroup>
                    {user?.customer?.customFields &&
                      Object.keys(user.customer.customFields).length > 0 && (
                        <optgroup label="Custom Fields">
                          {Object.keys(user.customer.customFields).map(
                            (fieldKey) => (
                              <option key={fieldKey} value={fieldKey}>
                                {fieldKey}
                              </option>
                            ),
                          )}
                        </optgroup>
                      )}
                  </Select>
                </Field>
              </>
            )}
          </>
        ) : selectedNode.data.type === "whatsapp_message_status" ? (
          <>
            <Text>
              Resuming flow when the contact opens the conversation (it does not
              work if the contact has deactivated read confirmation).
            </Text>
          </>
        ) : null}
      </>
    );
  } else if (selectedNode?.type === "tag") {
    return (
      <>
        <Heading className="text-lg">Add a tag</Heading>
        <br />
        {
          <ManageTagAutocomplete
            customerId={user.customerId}
            handleTagMessageChange={handleTagMessageChange}
          />
        }
      </>
    );
  } else if (selectedNode?.type === "trigger") {
    return (
      <ManageTrigger
        nodes={nodes}
        setNodes={setNodes}
        nodeData={selectedNode?.data}
        handleMessageChange={handleMessageChange}
      />
    );
  } else if (selectedNode?.type === "message") {
    return (
      <ManageMessage
        scenario={scenario}
        bodyRef={bodyRef}
        nodes={nodes}
        setNodes={setNodes}
        edges={edges}
        setEdges={setEdges}
        nodeId={selectedNode?.id}
        nodeData={selectedNode?.data}
        nodeType={selectedNode?.type}
        handleTypeChange={handleTypeChange}
        handleButtonChange={handleButtonChange}
        setModifications={setModifications}
        errors={messageErrors}
        setIsConvertCompressDialogOpen={setIsConvertCompressDialogOpen}
        setFile={setFile}
        setIsPanelOpened={setIsPanelOpened}
        isCompressing={isCompressing}
        setHeaderVideoLink={setHeaderVideoLink}
        selectedNodeConvertCompress={selectedNodeConvertCompress}
        setSelectedNodeConvertCompress={setSelectedNodeConvertCompress}
      />
    );
  } else if (selectedNode?.type === "template") {
    const handleLimitedTimeOfferChange = (value) => {
      handleMessageChange(
        "limitedTimeOffer",
        value,
        nodes,
        setNodes,
        selectedNode,
      );
    };

    return (
      <>
        <Heading className="text-lg flex align-center justify-between">
          <div className="flex items-center gap-2">
            {(selectedNode.data.whatsappTemplateName ?? "") === ""
              ? "Template selection"
              : "Template edition"}
            <Tooltip
              content="A template is a paying message needed to open a conversation with a contact. They must be submitted to Meta for approval before they can be used."
              size="4"
              placement="bottom"
            />
          </div>
          {!selectedNode.data.isTemplate &&
            selectedNode.data.whatsappTemplateName &&
            selectedNode.data.nodeId &&
            !selectedNode.data.cards &&
            !selectedNode.data.flowButton &&
            !selectedNode.data.limitedTimeOffer && (
              <Button onClick={handleConvertToAnswer}>Convert in Answer</Button>
            )}
        </Heading>

        {selectedNode.data.flowButton &&
          !selectedNode.data.isEditing &&
          selectedNode.data.whatsappTemplateName !== "" && (
            <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <Text className="text-xs text-amber-800">
                This template contains a WhatsApp Flow. Remember to declare the existing custom fields in Settings to save the Flow's answers →{" "}
                <Link href="/settings/whatsapp/flows" className="underline font-medium">
                  WhatsApp Flow
                </Link>
              </Text>
            </div>
          )}

        {selectedNode.data.whatsappTemplateName !== "" &&
          templates &&
          !selectedNode.data.isEditing && (
            <>
              {(() => {
                const selectedTemplate = Object.values(templates).find(
                  (template) =>
                    template.name === selectedNode.data.whatsappTemplateName,
                );

                if (
                  !selectedTemplate &&
                  !selectedNode.data.isPending &&
                  !selectedNode.data.isPending
                ) {
                  selectedNode.data.hasFailed = true;
                  return (
                    <Text className="text-red-600 text-xs">
                      This template does not exist
                    </Text>
                  );
                }

                if (
                  selectedTemplate &&
                  selectedTemplate.status.toLowerCase() !== "approved" &&
                  // selectedNode.data?.whatsappTemplateName === "" &&
                  !selectedNode.data?.isEditing &&
                  !selectedNode.data?.isPending
                ) {
                  selectedNode.data.hasFailed = true;
                  return (
                    <Text className="text-red-500 text-xs">
                      {selectedNode?.data?.status === "rejected"
                        ? "This template has been rejected by Meta"
                        : "This template is not approved by Meta yet"}
                    </Text>
                  );
                }
                return null;
              })()}
            </>
          )}

        {selectedNode.data?.isEditing ? (
          <>
            <TemplateForm
              api={api}
              user={user}
              edges={edges}
              setEdges={setEdges}
              templateName={templateName}
              setTemplateName={setTemplateName}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedHeader={selectedHeader}
              setSelectedHeader={setSelectedHeader}
              selectedCardsHeader={selectedCardsHeader}
              setSelectedCardsHeader={setSelectedCardsHeader}
              isLimitedTimeOffer={isLimitedTimeOffer}
              setIsLimitedTimeOffer={setIsLimitedTimeOffer}
              limitedTimeOffer={limitedTimeOffer}
              setLimitedTimeOffer={setLimitedTimeOffer}
              cards={cards}
              setCards={setCards}
              body={body}
              setBody={setBody}
              footer={footer}
              setFooter={setFooter}
              numberOfQuickReplies={numberOfQuickReplies}
              setNumberOfQuickReplies={setNumberOfQuickReplies}
              flowButton={selectedNode?.data?.flowButton}
              copyCodeButton={copyCodeButton}
              setCopyCodeButton={setCopyCodeButton}
              quickReply1={quickReply1}
              setQuickReply1={setQuickReply1}
              quickReply2={quickReply2}
              setQuickReply2={setQuickReply2}
              quickReply3={quickReply3}
              setQuickReply3={setQuickReply3}
              replyButtons={replyButtons}
              setReplyButtons={setReplyButtons}
              urlButton={urlButton}
              urlButton2={urlButton2}
              numberOfUrl={numberOfUrl}
              setNumberOfUrl={setNumberOfUrl}
              setUrlButton={setUrlButton}
              urlButtonLink={urlButtonLink}
              setUrlButtonLink={setUrlButtonLink}
              setUrlButton2={setUrlButton2}
              urlButtonLink2={urlButtonLink2}
              setUrlButtonLink2={setUrlButtonLink2}
              isUrlButtonAtBottom={isUrlButtonAtBottom}
              setIsUrlButtonAtBottom={setIsUrlButtonAtBottom}
              bodyParameters={bodyParameters}
              setBodyParameters={setBodyParameters}
              headerImageLink={headerImageLink}
              setHeaderImageLink={setHeaderImageLink}
              headerVideoLink={headerVideoLink}
              setHeaderVideoLink={setHeaderVideoLink}
              templateNameError={templateNameError}
              setTemplateNameError={setTemplateNameError}
              bodyErrorMsg={bodyErrorMsg}
              setBodyErrorMsg={setBodyErrorMsg}
              quickReply1ErrorMsg={quickReply1ErrorMsg}
              setQuickReply1ErrorMsg={setQuickReply1ErrorMsg}
              quickReply2ErrorMsg={quickReply2ErrorMsg}
              setQuickReply2ErrorMsg={setQuickReply2ErrorMsg}
              quickReply3ErrorMsg={quickReply3ErrorMsg}
              setQuickReply3ErrorMsg={setQuickReply3ErrorMsg}
              urlButtonErrorMsg={urlButtonErrorMsg}
              setUrlButtonErrorMsg={setUrlButtonErrorMsg}
              urlButtonLinkErrorMsg={urlButtonLinkErrorMsg}
              setUrlButtonLinkErrorMsg={setUrlButtonLinkErrorMsg}
              urlButton2ErrorMsg={urlButton2ErrorMsg}
              setUrlButton2ErrorMsg={setUrlButton2ErrorMsg}
              urlButtonLink2ErrorMsg={urlButtonLink2ErrorMsg}
              setUrlButtonLink2ErrorMsg={setUrlButtonLink2ErrorMsg}
              limitedTimeOfferTextError={limitedTimeOfferTextError}
              setLimitedTimeOfferTextError={setLimitedTimeOfferTextError}
              customField1ErrorMsg={customField1ErrorMsg}
              setCustomField1ErrorMsg={setCustomField1ErrorMsg}
              customField2ErrorMsg={customField2ErrorMsg}
              setCustomField2ErrorMsg={setCustomField2ErrorMsg}
              customField3ErrorMsg={customField3ErrorMsg}
              setCustomField3ErrorMsg={setCustomField3ErrorMsg}
              bodyCardErrors={bodyCardErrors}
              buttonCardErrors={buttonCardErrors}
              setBodyCardErrors={setBodyCardErrors}
              setButtonCardErrors={setButtonCardErrors}
              templateNameRef={templateNameRef}
              bodyRef={bodyRef}
              quickReply1Ref={quickReply1Ref}
              quickReply2Ref={quickReply2Ref}
              quickReply3Ref={quickReply3Ref}
              urlButtonLinkRef={urlButtonLinkRef}
              urlButtonLink2Ref={urlButtonLink2Ref}
              bodyCardRefs={bodyCardRefs}
              buttonCardRefs={buttonCardRefs}
              isInPanel={true}
              nodes={nodes}
              setNodes={setNodes}
              selectedNode={selectedNode}
              paramOptions={paramOptions}
              imageParamOptions={imageParamOptions}
              campaign={scenario.campaign}
              isUploading={isUploading}
              setIsUploading={setIsUploading}
              setModifications={setModifications}
              handleOpenProductPicker={handleOpenProductPicker}
              shopifyUpsellLineItems={shopifyUpsellLineItems}
              setShopifyUpsellLineItems={setShopifyUpsellLineItems}
              setIsPanelOpened={setIsPanelOpened}
              setFile={setFile}
              carouselCardIndex={carouselCardIndex}
              setCarouselCardIndex={setCarouselCardIndex}
              carouselComponentIndex={carouselComponentIndex}
              setCarouselComponentIndex={setCarouselComponentIndex}
              selectedNodeConvertCompress={selectedNodeConvertCompress}
              setSelectedNodeConvertCompress={setSelectedNodeConvertCompress}
              setIsConvertCompressDialogOpen={setIsConvertCompressDialogOpen}
            />
          </>
        ) : (
          <>
            <Field>
              <Legend>Template selection</Legend>
              {!selectedNode.data.isEditing ? (
                <SelectInput
                  placeholder="Select template"
                  onChange={(value) => {
                    console.log("submitting template");
                    setIsTemplateChanged(true);
                    selectedNode.isPending = false;
                    selectedNode.data.shouldBeReplaced =
                      selectedNode.data?.nodeId !== "";
                    if (
                      selectedNode.data.whatsappTemplateName &&
                      selectedNode.data.whatsappTemplateName !== "" &&
                      !selectedNode.data.oldData
                    ) {
                      selectedNode.data.oldData = JSON.parse(
                        JSON.stringify(selectedNode.data),
                      );
                    }
                    handleTemplateSelectionChange({
                      value,
                      nodes,
                      setNodes,
                      templates,
                      templatesByName,
                      api,
                    });
                  }}
                  value={selectedNode.data.whatsappTemplateName}
                  options={getTemplateOptions(templates)}
                  selected={selectedNode.data.whatsappTemplateName}
                  key={
                    selectedNode.data?.nodeId !== ""
                      ? "selectNewTemplate"
                      : "selectFirstTemplate"
                  }
                />
              ) : null}
            </Field>

            <Field>
              <div className="flex items-center">
                <Divider />
                <Text className="text-zinc-400 m-3 text-xs">OR</Text>
                <Divider />
              </div>

              <div className="flex justify-between">
                {selectedNode.data.whatsappTemplateName !== "" && (
                  <Button
                    className="text-sm text-gray-400  w-full mr-2"
                    color="optionButton"
                    onClick={() => {
                      console.log("edit");
                      selectedNode.data.isEditing = true;
                      setModifications(true);
                      if (
                        !selectedNode.data.oldData ||
                        selectedNode.data.oldData === "" ||
                        (selectedNode.data.oldData?.whatsappTemplateName ===
                          "" &&
                          selectedNode.data.oldData?.whatsappTemplateId === "")
                      ) {
                        console.log("ajoute old data dans edit template");
                        selectedNode.data.oldData = { ...selectedNode.data };
                      }
                      editTemplate();

                      console.log("edit template");
                    }}
                  >
                    Edit template
                  </Button>
                )}
                <Button
                  className="text-sm text-gray-400 w-full ml-2"
                  color="optionButton"
                  onClick={async () => {
                    setTemplateName("");
                    setSelectedHeader(["none"]);
                    setSelectedCategory(WhatsappTemplateCategoryEnum.UTILITY);
                    setLimitedTimeOffer(null);
                    setBody("");
                    setFooter("");
                    setNumberOfQuickReplies("");
                    setCopyCodeButton(null);
                    setQuickReply1("");
                    setQuickReply2("");
                    setQuickReply3("");
                    setReplyButtons([]);
                    setNumberOfUrl(0);
                    setUrlButton("");
                    setUrlButtonLink("");
                    setUrlButton2("");
                    setUrlButtonLink2("");

                    if (
                      !selectedNode.data.oldData ||
                      selectedNode.data.oldData === "" ||
                      selectedNode.data.oldData.whatsappTemplateName === ""
                    ) {
                      console.log("new template");
                      console.log(selectedNode);
                      selectedNode.data.oldData = { ...selectedNode.data };
                    }
                    // selectedNode.data.oldData = selectedNode.data;

                    Object.keys(selectedNode.data).forEach((key) => {
                      if (
                        key !== "oldData" &&
                        key !== "isEditing" &&
                        key !== "shouldBeReplaced" &&
                        key !== "clickNode" &&
                        key !== "buttons" &&
                        key !== "nodeId" &&
                        key !== "isTemplate" &&
                        key !== "whatsappTemplateName"
                      ) {
                        selectedNode.data[key] = null;
                      }
                    });
                    selectedNode.data.buttons = [];
                    selectedNode.data.category =
                      WhatsappTemplateCategoryEnum.UTILITY;
                    selectedNode.data.shouldBeReplaced = true;
                    selectedNode.data.isEditing = true;
                  }}
                >
                  New template
                </Button>
              </div>
            </Field>

            {selectedNode.data.whatsappTemplateName !== "" && (
              <>
                <aside className="fixed w-96 top-1/2 right-1/2 transform -translate-x-[63%] -translate-y-1/2 bg-white overflow-y-auto rounded-customBorderRadius max-h-[90vh] scroll-color">
                  <div className="m-3">
                    <Field>
                      <Legend>Preview</Legend>
                      <TemplatePreview
                        selectedHeader={
                          selectedNode.data.headerParameters?.type || "none"
                        }
                        imageUrl={
                          selectedNode.data.headerParameters?.image ===
                          "shopifyProductImage"
                            ? "https://storage.gadget.dev/files/22129/42940/media/file/O68TikY4GnkGUAzFNnGnB/c9168318-968c-4199-80dc-64da075a0aba"
                            : selectedNode.data.headerParameters?.image?.link
                        }
                        videoUrl={
                          selectedNode.data.headerParameters?.video?.link
                        }
                        isLimitedTimeOffer={
                          !!selectedNode.data.limitedTimeOffer
                        }
                        limitedTimeOffer={selectedNode.data.limitedTimeOffer}
                        cards={selectedNode.data.cards}
                        body={selectedNode.data.body}
                        footer={selectedNode.data.footer}
                        flowButton={selectedNode.data.flowButton}
                        copyCodeButton={selectedNode.data.copyCodeButton}
                        quickReply1={
                          selectedNode.data.buttons?.[0]?.title ?? ""
                        }
                        quickReply2={
                          selectedNode.data.buttons?.[1]?.title ?? ""
                        }
                        quickReply3={
                          selectedNode.data.buttons?.[2]?.title ?? ""
                        }
                        urlButton={selectedNode.data.urlButton?.text ?? ""}
                        urlButton2={selectedNode.data.urlButton2?.text ?? ""}
                        width="100%"
                        imageMaxHeight="100%"
                        isUrlButtonAtBottom={
                          selectedNode.data.isUrlButtonAtBottom ?? ""
                        }
                        isInPanel={true}
                      />
                    </Field>
                  </div>
                </aside>
                {Object.prototype.hasOwnProperty.call(
                  selectedNode.data?.headerParameters ?? {},
                  "image",
                ) && (
                  <>
                    <Field>
                      <Legend>Header image</Legend>
                      <Select
                        className="mb-2"
                        placeholder="Select a parameter"
                        label={`Header image`}
                        options={imageParamOptions}
                        onChange={(e) => {
                          let newParameters = {
                            type: "image",
                            image:
                              e.target.value === "custom"
                                ? { link: selectedNode.data.image }
                                : e.target.value,
                          };
                          handleMessageChange(
                            "headerParameters",
                            newParameters,
                            nodes,
                            setNodes,
                          );
                          setModifications(true);
                        }}
                        value={
                          selectedNode.data.headerParameters.image ===
                          "shopifyProductImage"
                            ? "shopifyProductImage"
                            : "custom"
                        }
                      >
                        {imageParamOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Select>
                    </Field>
                    {(selectedNode.data.headerParameters.image !==
                      "shopifyProductImage" ||
                      imageParamOptions.length === 1) && (
                      <Field>
                        <Input
                          name="Image URL"
                          key="Image_URL"
                          value={selectedNode.data.headerParameters.image?.link}
                          onChange={(e) => {
                            handleMessageChange(
                              "headerParameters",
                              {
                                type: "image",
                                image: {
                                  link: e.target.value,
                                },
                              },
                              nodes,
                              setNodes,
                            );
                            setModifications(true);
                          }}
                          placeholder="https://example.com/"
                          autoComplete="off"
                          maxLength={2000}
                        />
                      </Field>
                    )}

                    {selectedNode.data.headerParameters.image !==
                      "shopifyProductImage" && (
                      <>
                        <br />
                        <Dragger
                          name="file"
                          key="file"
                          showUploadList={false}
                          maxCount={1}
                          accept="image/jpeg,image/png,application/pdf"
                          disabled={isUploading}
                          multiple={false}
                          height={200}
                          beforeUpload={(file) => {
                            const isValid = handleBeforeUploadFile({
                              file: file,
                              setFile: setFile,
                              selectedHeader: "image",
                              setIsPanelOpened: setIsPanelOpened,
                              setIsConvertCompressDialogOpen:
                                setIsConvertCompressDialogOpen,
                              selectedNode: selectedNode,
                              selectedNodeConvertCompress:
                                selectedNodeConvertCompress,
                              setSelectedNodeConvertCompress:
                                setSelectedNodeConvertCompress,
                            });
                            return isValid;
                          }}
                          action={(file) =>
                            handleUploadFile({
                              file: file,
                              setIsUploading: setIsUploading,
                              user: user,
                              selectedNode: selectedNode,
                              nodes: nodes,
                              setHeaderImageLink: setHeaderImageLink,
                              setNodes: setNodes,
                              setModifications: setModifications,
                              selectedHeader: "image",
                            })
                          }
                          onDrop={(e) => {
                            console.log("Dropped files", e.dataTransfer.files);
                          }}
                        >
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Click or drag-and-drop a file to import it
                          </p>
                          <p className="ant-upload-hint">
                            Please upload a .jpeg or .png file. It must be less
                            than 5MB.
                          </p>
                        </Dragger>
                      </>
                    )}
                  </>
                )}
                {Object.prototype.hasOwnProperty.call(
                  selectedNode.data?.headerParameters ?? {},
                  "video",
                ) && (
                  <>
                    <Field>
                      <Legend>Video URL</Legend>
                      <Input
                        name="Video URL"
                        key="video_url"
                        value={selectedNode.data.headerParameters.video?.link}
                        onChange={(e) => {
                          handleMessageChange(
                            "video",
                            e.target.value,
                            nodes,
                            setNodes,
                          );
                          setModifications(true);
                        }}
                        placeholder="https://exemple.com/"
                        autoComplete="off"
                        maxLength={2000}
                      />
                    </Field>
                    <br />
                    <Dragger
                      name="file"
                      showUploadList={false}
                      maxCount={1}
                      accept="video/mp4"
                      disabled={isUploading}
                      multiple={false}
                      height={200}
                      beforeUpload={(file) => {
                        const isValid = handleBeforeUploadFile({
                          file: file,
                          selectedHeader: "video",
                        });
                        return isValid;
                      }}
                      action={(file) =>
                        handleUploadFile({
                          file: file,
                          setIsUploading: setIsUploading,
                          user: user,
                          selectedNode: selectedNode,
                          nodes: nodes,
                          setHeaderVideoLink: setHeaderVideoLink,
                          setNodes: setNodes,
                          setModifications: setModifications,
                          selectedHeader: "video",
                        })
                      }
                      onDrop={() => {}}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag-and-drop a file to import it
                      </p>
                      <p className="ant-upload-hint">
                        Please upload a .mp4 file smaller than 16MB
                      </p>
                    </Dragger>
                  </>
                )}

                <>
                  {selectedNode.data.limitedTimeOffer && (
                    <>
                      <Field>
                        <Legend>Limited-Time Offer</Legend>
                        <InputGroup>
                          <Input
                            className="focus:ring-0 mb-2"
                            placeholder="Text"
                            value={selectedNode.data.limitedTimeOffer.text}
                            disabled
                          />
                        </InputGroup>
                      </Field>
                      <LimitedTimeOffer
                        data={selectedNode.data.limitedTimeOffer}
                        handleLimitedTimeOfferChange={
                          handleLimitedTimeOfferChange
                        }
                        isEditing={false}
                        isInPanel={true}
                        setModifications={setModifications}
                      ></LimitedTimeOffer>
                    </>
                  )}
                  <Field>
                    <Divider className="mt-5" />
                    <Legend>Body</Legend>
                    <Textarea
                      name="Message"
                      key="message_body"
                      placeholder="Message body"
                      value={selectedNode.data.body?.trim()}
                      disabled
                      resizable={false}
                      maxLength={1024}
                      autoComplete="off"
                    />
                    {selectedNode.data?.bodyParameters &&
                      selectedNode.data.bodyParameters.length > 0 &&
                      selectedNode.data.bodyParameters.map((p, index) => (
                        <Field key={index + "field-body_params"}>
                          <Divider
                            className="mt-5 mb-3"
                            key={index + "divider"}
                          />
                          <Label
                            key={index + "label"}
                            className="font-bold"
                          >{`Parameter ${index + 1}`}</Label>
                          <Select
                            className="mb-2"
                            key={index + "bodyParam"}
                            placeholder="Select a parameter"
                            onChange={(e) => {
                              var newParams = [
                                ...selectedNode.data.bodyParameters,
                              ];
                              newParams[index] = {
                                type: "text",
                                selected: e.target.value,
                              };
                              handleMessageChange(
                                "bodyParameters",
                                newParams,
                                nodes,
                                setNodes,
                              );
                              setModifications(true);
                            }}
                            value={
                              selectedNode.data.bodyParameters[index].selected
                            }
                          >
                            {paramOptions.map((option, index) => (
                              <option
                                key={`${option.value}-${index}`}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            ))}
                          </Select>
                          <div className="flex justify-between items-center">
                            <Label key={index + "defaultLabel"}>
                              {"Default value"}
                            </Label>
                            <Input
                              className="max-w-[75%]"
                              type="text"
                              key={index + "defaultInput"}
                              placeholder="Value if parameter is empty"
                              autoComplete="off"
                              value={
                                selectedNode.data.bodyParameters[index]
                                  .default || ""
                              }
                              onChange={(e) => {
                                var newParams = [
                                  ...(selectedNode.data?.bodyParameters ?? []),
                                ];
                                newParams[index] = {
                                  ...newParams[index],
                                  default: e.target.value,
                                };
                                handleMessageChange(
                                  "bodyParameters",
                                  newParams,
                                  nodes,
                                  setNodes,
                                );
                                setModifications(true);
                              }}
                            />
                          </div>
                        </Field>
                      ))}
                    {selectedNode.data.footer && (
                      <>
                        <Divider className="mt-5 mb-3" />
                        <Legend>Footer</Legend>
                        <Textarea
                          name="Message"
                          key="message_footer"
                          placeholder="Message body"
                          value={selectedNode.data.footer}
                          disabled
                          resizable={false}
                          maxLength={20}
                          autoComplete="off"
                        />
                      </>
                    )}
                    <Divider className="mt-5" />
                  </Field>
                  {selectedNode.data.cards && (
                    <CarouselPanel
                      selectedNode={selectedNode}
                      isUploading={isUploading}
                      setIsUploading={setIsUploading}
                      api={api}
                      paramOptions={paramOptions}
                      user={user}
                      nodes={nodes}
                      setNodes={setNodes}
                      setCards={setCards}
                      setModifications={setModifications}
                      carouselCardIndex={carouselCardIndex}
                      setCarouselCardIndex={setCarouselCardIndex}
                      carouselComponentIndex={carouselComponentIndex}
                      setCarouselComponentIndex={setCarouselComponentIndex}
                      setFile={setFile}
                      setIsPanelOpened={setIsPanelOpened}
                      setIsConvertCompressDialogOpen={
                        setIsConvertCompressDialogOpen
                      }
                      selectedNodeConvertCompress={selectedNodeConvertCompress}
                      setSelectedNodeConvertCompress={
                        setSelectedNodeConvertCompress
                      }
                    />
                  )}

                  {selectedNode.data?.copyCodeButton && (
                    <Field>
                      <Legend>Copy code</Legend>
                      <div className="flex flex-row">
                        <InputGroup className="flex relative items-center">
                          <ClipboardDocumentIcon />
                          <Input
                            className="focus:ring-0"
                            placeholder="Code"
                            maxLength={15}
                            showCharacterCount
                            value={selectedNode.data.copyCodeButton.text ?? ""}
                            onChange={(e) =>
                              handleMessageChange(
                                "copyCodeButton",
                                { text: e.target.value },
                                nodes,
                                setNodes,
                              )
                            }
                          />
                        </InputGroup>
                      </div>
                    </Field>
                  )}

                  {selectedNode.data?.buttons?.map((button, index) => {
                    return (
                      <Field key={`field-${index}`}>
                        <Legend>{`Button ${index + 1}`}</Legend>
                        <div className="flex flex-row">
                          <InputGroup className="flex relative items-center">
                            <Input
                              name={`Button ${index + 1}`}
                              key={`input-${index}`}
                              value={button.title}
                              onChange={(e) =>
                                handleButtonChange(index, e.target.value, nodes)
                              }
                              disabled
                              maxLength={25}
                              showCharacterCount
                            />
                          </InputGroup>
                        </div>
                        {button?.customField && (
                          <div className="mt-3">
                            <div className="flex items-center gap-2 mb-2">
                              <Switch
                                color="yellow"
                                checked
                                className="rounded cursor-help disabled:bg-yellow-500 border-gray-300"
                              />
                              <label
                                htmlFor={`save-custom-field-${index}`}
                                className="text-sm text-gray-700 cursor-pointer"
                              >
                                Save the click as a custom field
                              </label>
                            </div>
                            <SelectInput
                              value={button.customField}
                              selected={button.customField}
                              placeholder={button.customField}
                              disabled
                            />
                            <Input
                              key={`Custom Field Value ${index}`}
                              disabled
                              value={button.customFieldValue}
                            />
                          </div>
                        )}
                      </Field>
                    );
                  })}

                  {selectedNode.data?.urlButton && (
                    <Field key="url-button-1">
                      <Legend>Link URL 1</Legend>
                      <div className="flex flex-row">
                        <InputGroup className="flex relative items-center">
                          <Input
                            name={`Link URL`}
                            key={`Input URL`}
                            value={selectedNode.data?.urlButton?.url?.replace(
                              /\{\{[^}]+\}\}/g,
                              "{{url_variable}}",
                            )}
                            disabled
                          />
                        </InputGroup>
                      </div>
                    </Field>
                  )}
                  {selectedNode.data?.urlButton2 && (
                    <Field key="url-button-2">
                      <Legend>Link URL 2</Legend>
                      <div className="flex flex-row">
                        <InputGroup className="flex relative items-center">
                          <Input
                            name={`Link URL 2`}
                            key={`Input URL 2`}
                            value={selectedNode.data?.urlButton2?.url?.replace(
                              /\{\{[^}]+\}\}/g,
                              "{{url_variable}}",
                            )}
                            disabled
                          />
                        </InputGroup>
                      </div>
                    </Field>
                  )}

                  {/* Upsell Products Button - Show if order-confirmation campaign with Shopify integration OR if upsell products are already selected */}
                  {((scenario.campaign?.automationType ===
                    "order-confirmation" &&
                    integrations?.shopify === true) ||
                    shopifyUpsellLineItems?.length > 0) && (
                    <Field key="upsell-products">
                      <div className="flex gap-3 my-2">
                        <Button
                          color="secondaryButton"
                          onClick={handleOpenProductPicker}
                        >
                          {shopifyUpsellLineItems?.length > 0 ? (
                            <ShoppingCartIcon className="h-4 w-4 mr-1" />
                          ) : (
                            <PlusIcon className="h-4 w-4 mr-1" />
                          )}
                          {shopifyUpsellLineItems?.length > 0
                            ? "Edit upsell products"
                            : "Insert upsell URL"}
                        </Button>
                      </div>
                    </Field>
                  )}

                  <br />
                </>
              </>
            )}
          </>
        )}
      </>
    );
  } else if (selectedNode?.type === "ai") {
    return (
      <>
        <AIChatbot
          selectedNode={selectedNode}
          user={user}
          handleMessageChange={handleMessageChange}
          setGaiaWebsiteDatasources={setGaiaWebsiteDatasources}
          nodes={nodes}
          setNodes={setNodes}
        ></AIChatbot>
      </>
    );
  } else if (selectedNode?.type === "automationTrigger") {
    const handleSelectTriggerChange = (value, nodes) => {
      const updatedNodes = [...nodes];
      const selectedNode = updatedNodes.find((n) => n.selected);
      selectedNode.data.type = value;
      api.campaign.update(campaignId, {
        automationType: value,
      });
      api.flowNode.update(selectedNode.data.nodeId, {
        automationTriggerType: value,
      });
      message.success("Automation trigger has been updated.");
    };

    const handleSelectAbandonedCheckoutDurationChange = (value, nodes) => {
      const updatedNodes = [...nodes];
      const selectedNode = updatedNodes.find((n) => n.selected);
      selectedNode.data.abandonedCartDelayInMinutes = value;
      api.flowNode.update(selectedNode.data.nodeId, {
        abandonedCartDelayInMinutes: value,
      });
    };
    return (
      <>
        <Heading className="text-lg">Automation trigger</Heading>
        <Text className="text-md">
          The flow will start after a specific event. Once the event happens,
          the WhatsApp template next to it will be sent.
        </Text>
        <Field>
          <Legend>Trigger</Legend>
          <SelectInput
            placeholder="Select event"
            value={selectedNode.data.type}
            onChange={(value) => handleSelectTriggerChange(value, nodes)}
            options={automationTriggerOptions}
            selected={selectedNode.data.type}
            disabled={true}
          />
        </Field>
        <Text className="text-sm pt-2">
          The trigger can not be changed after creation. To use an other trigger
          create a new automation{" "}
          <Link
            href="/automations/new"
            target="_blank"
            className="text-blue-700 underline underline-offset-1 hover:text-violet-700"
            title={`${window.location.origin}/automations/new`}
          >
            here
          </Link>{" "}
          or edit an existing one.
        </Text>
        {(selectedNode.data.type === "abandoned-cart" ||
          selectedNode.data.type === "just-abandoned-checkout") && (
          <>
            <Field>
              <Legend>Abandoned checkout waiting duration</Legend>
              <SelectInput
                placeholder="Select time between checkout and first message"
                value={selectedNode.data.abandonedCartDelayInMinutes}
                onChange={(value) =>
                  handleSelectAbandonedCheckoutDurationChange(value, nodes)
                }
                options={abandonedCheckoutDurationOptions}
                selected={selectedNode.data.abandonedCartDelayInMinutes}
              />
            </Field>
          </>
        )}
        {["klaviyo", "splio", "api", "batch"].includes(
          selectedNode.data.type,
        ) && (
          <>
            <Divider className="mt-5" />
            <Heading className="text-lg mt-5">
              {selectedNode.data.type === "klaviyo"
                ? "Klaviyo"
                : selectedNode.data.type === "splio"
                  ? "Splio"
                  : selectedNode.data.type === "batch"
                    ? "Batch"
                    : "API"}{" "}
              configuration
            </Heading>
            <Field>
              <Legend>Destination URL</Legend>
              <Input
                value={`https://app.getsimio.com/api/campaign/${campaignId}`}
                disabled
              />
            </Field>
            <Field>
              <Legend>Key</Legend>
              <Input value="SIMIO-API-KEY" disabled />
            </Field>
            <Field>
              <Legend>Value</Legend>
              <div className="flex flex-row">
                <InputGroup className="flex relative items-center">
                  <Input
                    name="Simio API key"
                    value={user.customer?.apiKeySimio}
                    disabled
                    autoComplete="off"
                    type={isSimioApiKeyVisible ? "text" : "password"}
                  />
                </InputGroup>
                <Button
                  color="optionButton"
                  className="ml-2"
                  onClick={() => setIsSimioApiKeyVisible((status) => !status)}
                >
                  <EyeIcon />
                </Button>
              </div>
            </Field>
            <Field>
              <Legend>JSON body</Legend>
              <Textarea
                disabled
                value={
                  selectedNode.data.type === "klaviyo"
                    ? `{
    "phone": "{{ person.phone_number|default:'' }}"
}`
                    : `{
    "phone": "33601020304"
}`
                }
              />
              <Description>
                You might need to add "customProperties" to send specific
                parameters.
              </Description>
            </Field>
          </>
        )}
      </>
    );
  } else if (selectedNode?.type === "note") {
    return (
      <>
        <Heading className="text-lg">Internal note</Heading>
        <Field>
          <Textarea
            placeholder="Your internal note"
            value={selectedNode.data.note}
            onChange={(e) =>
              handleMessageChange("note", e.target.value, nodes, setNodes)
            }
            maxLength={1024}
            autoComplete="off"
          />
        </Field>
      </>
    );
  } else if (selectedNode?.type === "condition") {
    const propertyOptions = [
      {
        value: "tags",
        label: "Tags",
        valueType: "text",
        operator: [
          {
            value: conditionOperators.contains,
            label: conditionOperators.contains,
          },
        ],
      },
      {
        value: "optin status",
        label: "Optin status",
        valueType: "boolean",
        operator: [
          { value: conditionOperators.is, label: conditionOperators.is },
        ],
        valueBoolean: [
          {
            value: true,
            label: "true",
          },
          {
            value: false,
            label: "false",
          },
        ],
      },
      {
        value: "contact was created",
        label: "Contact was created",
        valueType: "date",
        operator: [
          {
            value: conditionOperators.inTheLast,
            label: conditionOperators.inTheLast,
          },
        ],
      },
      {
        value: "random split",
        label: "Random split",
        valueType: "number",
        operator: [
          {
            value: conditionOperators.percentageOfYes,
            label: conditionOperators.percentageOfYes,
          },
        ],
      },
    ];

    // Ajouter "has placed order" seulement si integrations.shopify est défini
    if (integrations && integrations.shopify) {
      propertyOptions.push({
        value: "has placed order",
        label: "Has placed order",
        valueType: "date",
        operator: [
          {
            value: conditionOperators.inTheLast,
            label: conditionOperators.inTheLast,
          },
        ],
      });
    }

    const operatorOptions =
      propertyOptions.find((option) => option.value === selectedPropertyOption)
        ?.operator || [];

    const booleanOptions =
      propertyOptions.find((option) => option.value === selectedPropertyOption)
        ?.valueBoolean || [];

    const handlePropertyChange = (value) => {
      const selectedOption = propertyOptions.find((p) => p.value === value);

      const operatorSelectedOptions =
        propertyOptions.find((option) => option.value === value)?.operator ||
        [];
      setSelectedPropertyOption(value);
      setSelectedOperatorOption("");

      handleMessageChange("property", value, nodes, setNodes, selectedNode);
      handleMessageChange(
        "valueType",
        selectedOption?.valueType,
        nodes,
        setNodes,
        selectedNode,
      );

      handleMessageChange("trueCount", null, nodes, setNodes, selectedNode);
      handleMessageChange("falseCount", null, nodes, setNodes, selectedNode);

      selectedNode.data.operator = null;
      {
        operatorSelectedOptions.length === 1 &&
          handleMessageChange(
            "operator",
            operatorSelectedOptions[0].value,
            nodes,
            setNodes,
            selectedNode,
          );
        if (operatorSelectedOptions[0].value === conditionOperators.is) {
          setSelectedBooleanOption("true");
          handleMessageChange(
            "valueBoolean",
            true,
            nodes,
            setNodes,
            selectedNode,
          );
        }
        if (
          operatorSelectedOptions[0].value ===
          conditionOperators.percentageOfYes
        ) {
          setUnitPercentage(0);
          handleMessageChange(
            "valuePercentage",
            0,
            nodes,
            setNodes,
            selectedNode,
          );
        }
      }
      selectedNode.data.valueTag = {
        id: null,
        name: null,
      };
      selectedNode.data.valueBoolean = null;
      selectedNode.data.valueStartingPeriodInMinutes = null;
      selectedNode.data.valueType = null;
    };

    const handleOperatorChange = (value) => {
      setSelectedOperatorOption(value);
      handleMessageChange("operator", value, nodes, setNodes, selectedNode);
      if (
        selectedPropertyOption === "optin status" &&
        value === conditionOperators.is
      ) {
        setSelectedBooleanOption("true");
        handleMessageChange(
          "valueBoolean",
          true,
          nodes,
          setNodes,
          selectedNode,
        );
      }
      handleMessageChange("trueCount", null, nodes, setNodes, selectedNode);
      handleMessageChange("falseCount", null, nodes, setNodes, selectedNode);
    };

    const handleBooleanChange = (value) => {
      setSelectedBooleanOption(value);
      handleMessageChange("valueBoolean", value, nodes, setNodes, selectedNode);
      handleMessageChange(
        "valueType",
        "boolean",
        nodes,
        setNodes,
        selectedNode,
      );

      handleMessageChange("trueCount", null, nodes, setNodes, selectedNode);
      handleMessageChange("falseCount", null, nodes, setNodes, selectedNode);
    };

    const handlevalueStartingPeriodInMinutesChange = (value, time) => {
      let valueStartingPeriodInMinutes;
      if (time === "day") {
        valueStartingPeriodInMinutes =
          value * 1440 + conditionHour + conditionMinute;
      }
      if (time === "hour") {
        valueStartingPeriodInMinutes =
          conditionDay * 1440 + value * 60 + conditionMinute;
      }
      if (time === "minute") {
        valueStartingPeriodInMinutes =
          conditionDay * 1440 + conditionHour * 60 + parseInt(value, 10);
      }
      handleMessageChange(
        "valueStartingPeriodInMinutes",
        valueStartingPeriodInMinutes,
        nodes,
        setNodes,
        selectedNode,
      );

      handleMessageChange("trueCount", null, nodes, setNodes, selectedNode);

      handleMessageChange("falseCount", null, nodes, setNodes, selectedNode);
    };

    const InTheLastSelector = () => {
      return (
        <div>
          <Field className="flex items-center justify-between mt-3">
            <div className={timeSectionClasses}>
              <div className={inputClasses}>
                <Input
                  value={conditionDay}
                  placeholder={conditionDay === "" ? "0" : conditionDay}
                  type="number"
                  min={0}
                  onChange={(e) => {
                    setConditionDay(e.target.value);
                    handlevalueStartingPeriodInMinutesChange(
                      e.target.value,
                      "day",
                    );
                  }}
                />
              </div>
              <Label>{conditionDay > 1 ? "days" : "day"}</Label>
            </div>

            <div className={timeSectionClasses}>
              <div className={inputClasses}>
                <Input
                  value={conditionHour}
                  placeholder={conditionHour === "" ? "0" : conditionHour}
                  type="number"
                  max={23}
                  min={0}
                  onChange={(e) => {
                    setConditionHour(e.target.value);
                    handlevalueStartingPeriodInMinutesChange(
                      e.target.value,
                      "hour",
                    );
                  }}
                />
              </div>
              <Label>{conditionHour > 1 ? "hours" : "hour"}</Label>
            </div>
            <div className={timeSectionClasses}>
              <div className={inputClasses}>
                <Input
                  value={conditionMinute}
                  type="number"
                  max={59}
                  min={0}
                  placeholder={conditionMinute === "" ? "0" : conditionMinute}
                  onChange={(e) => {
                    setConditionMinute(e.target.value);
                    handlevalueStartingPeriodInMinutesChange(
                      e.target.value,
                      "minute",
                    );
                  }}
                />
              </div>
              <Label>{conditionMinute > 1 ? "minutes" : "minute"}</Label>
            </div>
          </Field>
        </div>
      );
    };

    return (
      <>
        <div className="flex justify-between">
          <Heading className="text-lg">Condition</Heading>
        </div>
        <>
          <Text>Condition</Text>
          <SelectInput
            placeholder={
              selectedPropertyOption === ""
                ? "Select a property"
                : selectedPropertyOption
            }
            options={propertyOptions}
            selected={selectedPropertyOption}
            onChange={(value) => handlePropertyChange(value)}
            value={selectedPropertyOption}
          />
          <br />
          {selectedNode.data.property && (
            <>
              <>
                <Text>Operator</Text>

                <SelectInput
                  placeholder={
                    selectedOperatorOption === ""
                      ? "Select an operator"
                      : selectedOperatorOption
                  }
                  options={operatorOptions}
                  selected={
                    operatorOptions.length === 1
                      ? operatorOptions[0].label
                      : selectedOperatorOption
                  }
                  onChange={(value) => handleOperatorChange(value)}
                  value={selectedOperatorOption}
                />
                <br />
              </>

              {selectedNode.data.property === "optin status" &&
                selectedNode.data.operator && (
                  <>
                    <Text>Optin status is: </Text>
                    {console.log(selectedBooleanOption)}
                    {console.log(booleanOptions)}
                    <SelectInput
                      placeholder={
                        selectedBooleanOption === ""
                          ? "Select a value"
                          : selectedBooleanOption
                      }
                      options={booleanOptions}
                      selected={selectedBooleanOption}
                      onChange={(value) => handleBooleanChange(value)}
                      value={selectedBooleanOption}
                    />
                    <br />
                  </>
                )}
              {selectedNode.data.property === "tags" &&
                selectedNode.data.operator && <>{TagAutocompleteCondition}</>}
              {selectedNode.data.property === "contact was created" &&
                selectedNode.data.operator && (
                  <>
                    <Text>The contact was created is the last</Text>
                    <InTheLastSelector />
                  </>
                )}
              {selectedNode.data.property === "has placed order" &&
                selectedNode.data.operator && (
                  <>
                    <Text>The client has placed an order is the last</Text>
                    <InTheLastSelector />
                  </>
                )}
              {selectedNode.data.property === "random split" &&
                selectedNode.data.operator && (
                  <>
                    <Text>Percentage: </Text>
                    <div className="flex items-end">
                      <div className="w-40">
                        <Input
                          value={unitPercentage}
                          type="number"
                          max={100}
                          min={0}
                          step="0.01"
                          placeholder={
                            unitPercentage === "" ? "0" : unitPercentage
                          }
                          onChange={(e) => {
                            setUnitPercentage(e.target.value);
                            handleMessageChange(
                              "valuePercentage",
                              e.target.value === ""
                                ? null
                                : Number(e.target.value),
                              nodes,
                              setNodes,
                              selectedNode,
                            );

                            handleMessageChange(
                              "trueCount",
                              null,
                              nodes,
                              setNodes,
                              selectedNode,
                            );

                            handleMessageChange(
                              "falseCount",
                              null,
                              nodes,
                              setNodes,
                              selectedNode,
                            );
                          }}
                        />
                      </div>

                      <Text className="ml-2 mb-1">%</Text>
                    </div>

                    <br />
                  </>
                )}
            </>
          )}
        </>
      </>
    );
  } else if (selectedNode?.type === "webhook") {
    return (
      <WebhookNodePanel
        headers={headers}
        setHeaders={setHeaders}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        pathParams={pathParams}
        setPathParams={setPathParams}
        configResponse={configResponse}
        setConfigResponse={setConfigResponse}
        jsonError={jsonError}
        setJsonError={setJsonError}
        testRequestLoading={testRequestLoading}
        setTestRequestLoading={setTestRequestLoading}
        isSidePanelVariableOpen={isSidePanelVariableOpen}
        setIsSidePanelVariableOpen={setIsSidePanelVariableOpen}
        isSidePanelTestOpen={isSidePanelTestOpen}
        setIsSidePanelTestOpen={setIsSidePanelTestOpen}
        lastContact={lastContact}
        setLastContact={setLastContact}
        exampleContactPhone={exampleContactPhone}
        setExampleContactPhone={setExampleContactPhone}
        exampleContactError={exampleContactError}
        setExampleContactError={setExampleContactError}
        exampleContactLoading={exampleContactLoading}
        setExampleContactLoading={setExampleContactLoading}
        responseTestRequest={responseTestRequest}
        setResponseTestRequest={setResponseTestRequest}
        variableCopied={variableCopied}
        setVariableCopied={setVariableCopied}
        textareaJsonBodyRef={textareaJsonBodyRef}
        nodes={nodes}
        setNodes={setNodes}
        user={user}
        selectedNode={selectedNode}
        api={api}
        validateJson={validateJson}
      />
    );
  }
};

export const automationTriggerOptions = [
  { value: "abandoned-cart", label: "Abandoned checkout" },
  {
    value: "just-abandoned-checkout",
    label: "Abandoned checkout (with JUST checkout)",
  },
  { value: "order-confirmation", label: "Order paid" },
  { value: "order-tracking", label: "Order shipped" },
  { value: "back-in-stock", label: "Back in stock" },
  { value: "optin-confirmation", label: "Optin confirmation" },
  { value: "api", label: "API" },
  { value: "klaviyo", label: "Klaviyo webhook" },
  { value: "splio", label: "Splio webhook" },
  { value: "batch", label: "Batch universal channel" },
];

export const abandonedCheckoutDurationOptions = [
  { label: "30 minutes", value: 30 },
  { label: "1 hour", value: 60 },
  { label: "2 hours", value: 120 },
  { label: "3 hours", value: 180 },
  { label: "4 hours", value: 240 },
  { label: "8 hours", value: 480 },
  { label: "12 hours", value: 720 },
  { label: "1 day", value: 1440 },
  { label: "2 days", value: 2880 },
  { label: "3 days", value: 4320 },
  { label: "5 days", value: 7200 },
  { label: "7 days", value: 10080 },
];

export const durationOptions = [
  { label: "1 minute", value: "1" },
  { label: "5 minutes", value: "5" },
  { label: "15 minutes", value: "15" },
  { label: "30 minutes", value: "30" },
  { label: "1 hour", value: "60" },
  { label: "2 hours", value: "120" },
  { label: "4 hours", value: "240" },
  { label: "8 hours", value: "480" },
  { label: "12 hours", value: "720" },
  { label: "1 day", value: "1440" },
  { label: "2 days", value: "2880" },
  { label: "3 days", value: "4320" },
  { label: "5 days", value: "7200" },
  { label: "7 days", value: "10080" },
  { label: "8 days", value: "11520" },
  { label: "10 days", value: "14400" },
  { label: "20 days", value: "28800" },
  { label: "40 days", value: "57600" },
];

function getTemplateOptions(templates) {
  const approved = templates?.filter(
    (t) => t.status?.toLowerCase() == "approved",
  );
  const options = approved?.map((t, index) => ({
    key: `${index}-option`,
    label: `${t.name}${
      t?.created_at ? ` (${t?.created_at?.slice(0, 10)})` : ""
    }`,
    value: t.name,
    created_at: t?.created_at,
  }));
  options?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return options;
}
